import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import { Formik, Form, Field, FieldArray } from "formik";
import * as actions from "./_redux/Actions";
import SearchMultiSelectInput from "../../components/SelectComponents/SearchMultiSelectInput";
import Select from "react-select";
import GameSelectInput from "../../components/SelectComponents/GameSelectInput";
import { Col, Row } from "react-bootstrap";
import Upload from "../../components/upload/Upload";
import CKEditor from "react-ckeditor-component";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import moment from "moment";
import { Multiselect } from "multiselect-react-dropdown";
import * as UIHelpers from "../../components/UIHelpers";
import  {imageUrl} from "../../components/UIHelpers";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import { useSubheader } from "../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  DatePickerField,
  ModalProgressBar,
  Input,
  TimePickerField,
  CustomeSelect,
} from "../../../_metronic/_partials/controls";
import { DateTimePicker, TimePicker } from "react-tempusdominus-bootstrap";
import "tempusdominus-bootstrap/src/sass/tempusdominus-bootstrap-build.scss";

const steps = [
  {
    title: "General",
    code: "generalStep",
    icon: "flaticon-calendar-1",
  },
  {
    title: "Game",
    code: "gameStep",
    icon: "flaticon-settings-1",
  },
  {
    title: "Prizepool",
    code: "prizepoolStep",
    icon: "flaticon-price-tag",
  },
  {
    title: "Rounds",
    code: "roundStep",
    icon: "flaticon-list",
  },
  {
    title: "Settings",
    code: "settingStep",
    icon: "flaticon-settings",
  },
  {
    title: "Summary",
    code: "summaryStep",
    icon: "flaticon2-check-mark",
  },
];

export const typeArr = [
  { value: "amount", label: "Amount" },
  { value: "rewards", label: "Rewards" },
];

const GamerjiTournament = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [title, setTitle] = useState("");
  const suhbeader = useSubheader();
  const [current, setCurrent] = useState(0);
  const { id } = useParams();
  const [isDateModified, setIsDateModified] = useState(false);
  const [frmInitialValues, setFrmInitialValues] = useState({
    countries: [],
    title: "",
    slogan: "",
    descriptions: "",
    startDate: null,
    endDate: null,
    winningTerm: "rank",
    featuredImage: {},
    currency: "",
    game: "",
    gameType: "",
    isVisible: "true",
    status: "waiting",
    isFeatured: "false",
    isCustomRank: "false",
    // isPrivate: "false",
    isConfirmStatus: "true",
    titles: [
      { name: "title1", value: "", isContest: true, isSelection: false },
      { name: "title2", value: "", isContest: true, isSelection: false },
      { name: "title3", value: "", isContest: true, isSelection: false },
      { name: "title4", value: "", isContest: true, isSelection: false },
    ],
    prizePoolType: "",
    prizePool: 0,
    prizePooInfo: [],
    pointPoolInfo: [],
    entryFee: 0,
    platformFee: 0,
    // prizePool: 0,
    prizepool: [],
    pointpool: [],
    perKill: 0,
    totalPlayers: 0,
    totalWinners: 0,
    rules: "",
    isShared: "true",
    // tournamentFormat: "",
    // formatInformation: "",
    rounds: [
      {
        name: "",
        isFinalRound: "no",
        matches: [
          {
            matchId: "",
            date: "",
            time: "",
            userCount: "",
            winnerCount: "",
            contest: [],
          },
        ],
      },
    ],
    // rounds: [],
    isActive: true,
  });

  const [activeGameType, setActiveGameType] = useState(0);

  const [
    countrySelectedDropdownFilterData,
    setCountryListDropdownFilterData,
  ] = useState([]);
  const [countryDropdownFilterData, setCountryDropdownFilterData] = useState(
    []
  );

  const [
    contestForSelectedDropdownFilterData,
    setContestForListDropdownFilterData,
  ] = useState([]);
  const [
    contestForDropdownFilterData,
    setContestForDropdownFilterData,
  ] = useState([]);
  const [
    allContestForDropdownFilterData,
    setAllContestForDropdownFilterData,
  ] = useState([]);

  const [companyInOutCurrency, setCompanyInOutCurrency] = useState([
    {
      companyId: "",
      inCurrency: "",
      outCurrency: "",
      companyCurrency: [],
      // selectedCompany: {},
      touranmentVisibility: "portal",
      touranmentStatus: "true",
      isFeatured: "false",
    },
  ]);
  const [
    currencyWiseCompanySelectedDropdownFilterData,
    setCurrencyWiseCompanyListDropdownFilterData,
  ] = useState([]);
  const [isSubmitBtnDisable, setIsSubmitBtnDisable] = useState(false);

  const [
    prizePoolTypeSelectedDropdownFilterData,
    setPrizePoolTypeListDropdownFilterData,
  ] = useState(null);

  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [game, setGame] = useState(undefined);
  const [gameType, setGameType] = useState(undefined);
  const [rules, setRules] = useState({});
  const [totalWinners, setTotalWinners] = useState(0);
  const [totalPointWinners, setTotalPointWinners] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [prize, setTotalPrize] = useState("");
  const [isAddRound, setIsAddRound] = useState(true);
  const [isBtnDisable, setIsBtnDisable] = useState(false);
  const [maps, setMaps] = useState([]);
  const [perspectives, setPerspectives] = useState([]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [tableImage, setTableImage] = useState({});
  const [bannerImage, setBannerImage] = useState({});
  const [creatives, setCreatives] = useState({});
  const [isInputDisable, setIsInputDisable] = useState(false);
  const [lastSelectedGame, setLastGame] = useState("");
  const [perRankFromAndTo, setPerRankFromAndTo] = useState([]);
  const [clickCheck, setClickCheck] = useState(false);
  const [enteredPrizes, setEnteredPrizes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [costumRank, setCostumRank] = useState(true);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );

  const {
    actionsLoading,
    tournamentForEdit,
    countryDropdownList,
    currencyDropdownList,
    companyDropdownList,
    listLoading,
    singleCompanyFetched,
    singleCompanyId,
    gameTypeData,
  } = currentState;

  useEffect(() => {
    let _title = id ? "Edit Gamerji Tournament" : "Gamerji Tournament";

    setTitle(_title);
    suhbeader.setTitle(_title);

    dispatch(actions.getEditTournamentById(id));
  }, [id]);

  useEffect(() => {
    // console.log("RULES-----", rules);
  }, [rules]);

  useEffect(() => {
    // dispatch(actions.fetchCountriesList());
    let filterCond = {};
      filterCond.search = {};
    filterCond.search.isShared = true;
    
    dispatch(actions.fetchCountriesDropdownListAction("countries"));
    dispatch(actions.fetchCompanyDropdownList(filterCond));
  }, [dispatch]);

  useEffect(() => {
    // dispatch(actions.fetchCountriesList());
    // dispatch(actions.fetchGameListTournaments());
  }, [dispatch]);

  useEffect(() => {
    // dispatch(actions.fetchCountriesList());
    // dispatch(actions.fetchGameTypeTournaments());
  }, [dispatch]);

  useEffect(() => {
    // dispatch(actions.fetchCountriesList());
    // dispatch(actions.fetchCurrencyDropdownListAction("countries"));
  }, [dispatch]);

  const currencyDropdownFilterData = [
    { label: "USD - United States Dollar", value: "USD" },
    { label: "EUR - Euro", value: "EUR" },
  ];

  const GetNoOfMatches = (data) => {
    let noOfmatches = 0;
    data.rounds.forEach((round) => (noOfmatches += round.matches.length));

    return noOfmatches;
  };

  useEffect(() => {
    if (countryDropdownList && countryDropdownList?.data) {
      let temp = [];
      countryDropdownList.data.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });
      setCountryDropdownFilterData(temp);
    }
  }, [countryDropdownList]);

  useEffect(() => {
    if (companyDropdownList && companyDropdownList?.data) {
      let temp = [];
      const userdata = JSON.parse(localStorage.getItem("userData"));
      const userCompany = userdata?.company || [];
      companyDropdownList.data.forEach((element, i) => {
        if (userCompany.includes(element._id)) {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      }
      });
      setAllContestForDropdownFilterData(temp);
      setContestForDropdownFilterData(temp);
    }
  }, [companyDropdownList]);

  useEffect(() => {
    if (singleCompanyId && singleCompanyFetched?.length > 0) {
      let tmp = [...companyInOutCurrency];
      for (let i = 0; i < tmp.length; i++) {
        if (singleCompanyId == tmp[i].companyId) {
          tmp[i].companyInOutCurrency = singleCompanyFetched;
          setCompanyInOutCurrency(tmp);
        }
      }
    }
  }, [singleCompanyFetched]);

  useEffect(() => {
    if (tournamentForEdit && id) {
      let data = { ...frmInitialValues, ...tournamentForEdit };
      let selectedCountryArray = [],
        selectedContestForArray = [];
      // console.log("***********************countryDropdownList", tournamentForEdit.countries)
      let selectedCom = countryDropdownFilterData.filter((e) =>
        tournamentForEdit?.countries?.includes(e.value)
      );
      // console.log("###########################", selectedCom)
      for (let i = 0; i < selectedCom?.length; i++) {
        selectedCountryArray.push({
          label: selectedCom[i].label,
          value: selectedCom[i].value,
        });
      }
      for (let i = 0; i < tournamentForEdit?.contestForAry?.length; i++) {
        selectedContestForArray.push({
          label: tournamentForEdit?.contestForAry[i]?.name,
          value: tournamentForEdit?.contestForAry[i]?._id,
        });
      }
      setCountryListDropdownFilterData(selectedCountryArray);
      setContestForListDropdownFilterData(selectedContestForArray);

      setLastGame(tournamentForEdit.game);

      data.game =
        tournamentForEdit && tournamentForEdit.game && tournamentForEdit.game;
      data.gameType =
        tournamentForEdit &&
        tournamentForEdit.gameType &&
        tournamentForEdit.gameType;
      data.isVisible =
        tournamentForEdit && tournamentForEdit.isVisible ? "true" : "false";
      data.isShared =
        tournamentForEdit && tournamentForEdit.isShared ? "true" : "false";
      data.isCustomRank =
        tournamentForEdit && tournamentForEdit.isCustomRank ? "true" : "false";
      data.startDate = tournamentForEdit && tournamentForEdit.startDate;
      setTableImage(tournamentForEdit && tournamentForEdit.eventTableImage);
      setBannerImage(tournamentForEdit && tournamentForEdit.bannerImage);
      setCreatives(tournamentForEdit && tournamentForEdit.creatives);
      setFeaturedImage(
        tournamentForEdit?.featuredImage?.default
          ? { default: tournamentForEdit.featuredImage.default }
          : null
      );
      setRules(tournamentForEdit && tournamentForEdit.rules);
      setGame(tournamentForEdit.gameAry);
      setGameType(tournamentForEdit.gameTypeAry);
      setMaps(
        tournamentForEdit.gameAry &&
          tournamentForEdit.gameAry.settings &&
          tournamentForEdit.gameAry.settings.title1Values
      );
      setPerspectives(
        tournamentForEdit.gameAry &&
          tournamentForEdit.gameAry.settings &&
          tournamentForEdit.gameAry.settings.title2Values
      );
      setFrmInitialValues(data);

      let contestInfoAry = [],
        contestInfoAryCompany = [];
      for (let i = 0; i < tournamentForEdit?.contestFor?.length; i++) {
        contestInfoAry.push({
          companyId: tournamentForEdit?.contestFor[i].companyId,
          inCurrency: tournamentForEdit?.contestFor[i].inCurrency,
          outCurrency: tournamentForEdit?.contestFor[i].outCurrency,
          companyInOutCurrency:
            tournamentForEdit?.contestFor[i].companyInOutCurrency,
          selectedCompany: {
            label: tournamentForEdit?.contestFor[i]?.selectedCompany?.label,
            value: tournamentForEdit?.contestFor[i]?.selectedCompany?.value,
          },
          // touranmentVisibility:
          //   tournamentForEdit?.contestFor[i]?.touranmentVisibility,
          touranmentStatus: tournamentForEdit?.contestFor[i]?.touranmentStatus,
          isFeatured: tournamentForEdit?.contestFor[i]?.isFeatured,
        });
        contestInfoAryCompany.push(tournamentForEdit?.contestFor[i]?.companyId);
      }
      setCompanyInOutCurrency(contestInfoAry);
      setCurrencyWiseCompanyListDropdownFilterData(contestInfoAryCompany);

      for (let i = 0; i < typeArr.length; i++) {
        if (typeArr[i].value === tournamentForEdit?.prizePoolType) {
          setPrizePoolTypeListDropdownFilterData({
            label: typeArr[i].label,
            value: typeArr[i].value,
          });
        }
      }

      let totalAmount = 0;
      let totalWinners = 0;
      let prize = 0; // Declare prize using let instead of const

      tournamentForEdit &&
        tournamentForEdit?.prizePooInfo &&
        tournamentForEdit.prizePooInfo.forEach((tournamentForEdit, index) => {
          let rF = tournamentForEdit.rankFrom;
          let rT = tournamentForEdit.rankTo;
          let aT = tournamentForEdit.totalAmount;
          let pP = tournamentForEdit?.prize;

          if (parseInt(rF) === 0 && parseInt(rT) > 0) {
            totalWinners++;
          } else if (parseInt(rT) === parseInt(rF)) {
            totalWinners++;
          } else if (parseInt(rT) > parseInt(rF)) {
            totalWinners += parseInt(rT) - parseInt(rF) + 1;
          } else if (parseInt(rF) > parseInt(rT)) {
            totalWinners++;
          }

          if (aT) {
            totalAmount += parseInt(aT);
          }
          if (pP) {
            prize += parseInt(pP);
          }
        });

      setTotalPrize(prize);
      setTotalAmount(totalAmount);
      setTotalWinners(totalWinners);
      setIsInputDisable(true);

      let totalPointWinners = 0;
      // console.log(tournamentForEdit, "------------");
      tournamentForEdit &&
        tournamentForEdit?.pointpool &&
        tournamentForEdit.pointpool.forEach((item, index) => {
          let rF = item.rankFrom;
          let rT = item.rankTo;

          if (parseInt(rF) === 0 && parseInt(rT) > 0) {
            totalPointWinners++;
          } else if (parseInt(rT) === parseInt(rF)) {
            totalPointWinners++;
          } else if (parseInt(rT) > parseInt(rF)) {
            totalPointWinners += parseInt(rT) - parseInt(rF) + 1;
          } else if (parseInt(rF) > parseInt(rT)) {
            totalPointWinners++;
          }
        });
      setTotalPointWinners(totalPointWinners);
      // setCurrent(4);
    }
  }, [tournamentForEdit, countryDropdownFilterData]);

  const addInput = () => {
    setCompanyInOutCurrency((t) => {
      return [
        ...t,
        {
          companyId: "",
          inCurrency: "",
          outCurrency: "",
          companyInOutCurrency: [],
          touranmentVisibility: "portal",
          touranmentStatus: "true",
          isFeatured: "false",
        },
      ];
    });
  };

  const removeTechInput = (index) => {
    const temp = [...companyInOutCurrency];
    temp.splice(index, 1);
    setCompanyInOutCurrency(temp);
    const tempCompany = [...currencyWiseCompanySelectedDropdownFilterData];
    tempCompany.splice(index, 1);
    setCurrencyWiseCompanyListDropdownFilterData(tempCompany);
  };

  useEffect(() => {
    // console.log(
    //   "currencyWiseCompanySelectedDropdownFilterData : ",
    //   currencyWiseCompanySelectedDropdownFilterData
    // );
    const tempCompany = allContestForDropdownFilterData.filter(
      (a) => !currencyWiseCompanySelectedDropdownFilterData?.includes(a?.value)
    );
    setContestForDropdownFilterData([...tempCompany]);
  }, [currencyWiseCompanySelectedDropdownFilterData]);

  const onChangeContestForListDropdownFilterData = (selectedComp) => {
    dispatch(actions.fetchSingleCompany(selectedComp?.value));
    let tmp = [...companyInOutCurrency];
    let obj = {
      companyId: selectedComp?.value,
      inCurrency: "",
      outCurrency: "",
      selectedCompany: selectedComp,
      companyInOutCurrency: singleCompanyFetched,
      touranmentVisibility: "portal",
      touranmentStatus: "true",
      isFeatured: "false",
    };

    if (
      tmp[selectedComp?.index] !== null &&
      tmp[selectedComp?.index] !== undefined
    ) {
      tmp[selectedComp?.index] = obj;
      setCompanyInOutCurrency(tmp);
    }

    let tmpCompany = [...currencyWiseCompanySelectedDropdownFilterData];

    tmpCompany[selectedComp?.index] = selectedComp?.value;
    setCurrencyWiseCompanyListDropdownFilterData(tmpCompany);
  };

  const onChangeInOutCurrency = (inOutcUR) => {
    let tmp = [...companyInOutCurrency];

    if (inOutcUR.cType == "in") {
      if (tmp[inOutcUR?.index] !== null && tmp[inOutcUR?.index] !== undefined) {
        let tmpObj = tmp[inOutcUR?.index];
        tmpObj.inCurrency = inOutcUR;
        tmp[inOutcUR?.index] = tmpObj;
        setCompanyInOutCurrency(tmp);
      }
    }

    if (inOutcUR.cType == "out") {
      if (tmp[inOutcUR?.index] !== null && tmp[inOutcUR?.index] !== undefined) {
        let tmpObj = tmp[inOutcUR?.index];
        tmpObj.outCurrency = inOutcUR;
        tmp[inOutcUR?.index] = tmpObj;
        setCompanyInOutCurrency(tmp);
      }
    }
  };

  const backToList = () => {
    history.push(`/tournaments/list`);
  };

  const handleChangeCoustomRank = (event, values) => {
    // console.log("ttttttvalues", values.winningTerm, values.isCustomRank)
    // console.log(event.target.value);
    if (values.winningTerm) setCostumRank();
  };

  useEffect(() => {
    // console.log("################values costumRank", costumRank)
  }, [costumRank]);

  const next = (values) => {
    if (values.winningTerm === "rank") {
      setCostumRank(true);
    } else {
      setCostumRank(false);
    }

    // console.log("################values", values.winningTerm, values.isCustomRank, costumRank)
    // console.log("next fun call",current, isDateModified)
    // values.rounds.forEach((round,rind)=>{
    //   console.log("round"+rind, round.isSaved)
    // })
    let errMsg = "";
    if (current === 0) {
      if (countrySelectedDropdownFilterData.length <= 0) {
        errMsg = "Please select country";
      } else if (!values.title) {
        errMsg = "Please add title!";
      } else if (!values.slogan) {
        errMsg = "Please add slogan!";
      } else if (!values.descriptions) {
        errMsg = "Please add description!";
      } else if (!values.startDate) {
        errMsg = "Please add start date and time";
      } else if (!values.endDate) {
        errMsg = "Please add end date and time";
      } else if (moment(values.endDate).isBefore(moment(values.startDate))) {
        // Check if end date is before start date
        NotificationManager.error(
          "End date should not be less then start date",
          "Error"
        );
        return;
      } else if (!values.winningTerm) {
        errMsg = "Please add Winning term";
      } else if (!featuredImage || !featuredImage?.default || !imageUrl(featuredImage.default).startsWith("http")) {
        errMsg = "Please upload featured image";
      } else {
        // companyInOutCurrency.forEach((euser, index) => {
        //   if (!euser.companyId) {
        //       errMsg = `Please select company ${index + 1}`;
        //       return;
        //   }
        //   if (!euser.inCurrency) {
        //       errMsg = `Please select in currency for company ${index + 1}`;
        //       return;
        //   }
        //   if (!euser.outCurrency) {
        //       errMsg = `Please select out currency for company ${index + 1}`;
        //       return;
        //   }
        // })
        if (
          values?.isShared === true ||
          (values?.isShared === "true" && companyInOutCurrency.length <= 1)
        ) {
          NotificationManager.error(
            "Please select more than one company",
            "Error"
          );
          return;
        } else if (
          values?.isShared === true ||
          (values?.isShared === "true" && companyInOutCurrency.length > 1)
        ) {
          companyInOutCurrency.forEach((euser, index) => {
            if (!euser.companyId) {
              errMsg = `Please select company ${index + 1}`;
              return;
            }
            if (!euser.inCurrency) {
              errMsg = `Please select in currency for company ${index + 1}`;
              return;
            }
            if (!euser.outCurrency) {
              errMsg = `Please select out currency for company ${index + 1}`;
              return;
            }
          });
        } else {
          companyInOutCurrency.forEach((euser, index) => {
            if (!euser.companyId) {
              errMsg = `Please select company ${index + 1}`;
              return;
            }
            if (!euser.inCurrency) {
              errMsg = `Please select in currency for company ${index + 1}`;
              return;
            }
            if (!euser.outCurrency) {
              errMsg = `Please select out currency for company ${index + 1}`;
              return;
            }
          });
        }
      }
    }
    if (current === 1) {
      if (!values.game) {
        errMsg = "Please select game";
      } else if (!values.gameType) {
        errMsg = "Please select game type";
      } else if (!values.titles) {
        errMsg = "Please update the game setting";
      } else if (values.titles) {
        values.titles.forEach((item) => {
          if (item.isContest && item.name && !item.value) {
            errMsg = `Please select ${item.name}`;
          }
        });
      }
      // else if (values.titles) {
      //   let gameSettingUpdate = values.titles.filter((item) => {
      //     if (item.name) {
      //       return item;
      //     }
      //   });
      //   if (gameSettingUpdate && gameSettingUpdate.length === 0) {
      //     errMsg = `Please update the game ${game.name} setting!`;
      //   } else {
      //     values.titles.forEach((item) => {
      //       if (item.name && item.type && !item.value) {
      //         errMsg = `Please select ${item.name}`;
      //       }
      //     });
      //   }
      // }
    }
    if (current === 2) {
      if (!values.totalPlayers) {
        errMsg = "Please add total players!";
      } else if (
        values.winningTerm === "point base" &&
        (!values.killPoints || values.killPoints === 0)
      ) {
        errMsg = "Please add kill points!";
      } else if (
        !prizePoolTypeSelectedDropdownFilterData &&
        !prizePoolTypeSelectedDropdownFilterData?.value
      ) {
        errMsg = "Please Select Prize Pool Type!";
      } else if (
        prizePoolTypeSelectedDropdownFilterData?.value &&
        prizePoolTypeSelectedDropdownFilterData?.value === "amount" &&
        (!values.prizePool || values.prizePool === 0)
      ) {
        errMsg = "Please add Prize Pool!";
      } else if (
        prizePoolTypeSelectedDropdownFilterData?.value &&
        prizePoolTypeSelectedDropdownFilterData?.value === "rewards" &&
        !values.rewardDisplayText
      ) {
        errMsg = "Please add Reward Display Text!";
      } else if (
        values.winningTerm === "rank" &&
        values.prizePooInfo.length <= 0
      ) {
        errMsg = "Please add prize Pool!";
      } else if (!values.totalWinners) {
        errMsg = "Please add total winners!";
      } else if (values.totalWinners > values.totalPlayers) {
        errMsg = "total winners is should not more than total players!";
      } else if (!(values.totalWinners === totalWinners)) {
        errMsg = "total winners should be same!";
      } else if (values.prizePooInfo && values.prizePooInfo.length <= 0) {
        errMsg = "Please add prize pool info!";
      } else if (
        prizePoolTypeSelectedDropdownFilterData?.value &&
        prizePoolTypeSelectedDropdownFilterData?.value === "amount" &&
        parseInt(values.prizePool) !== parseInt(totalAmount)
      ) {
        errMsg = "Total winning amount and prize pool amount should be same!";
      } else if (
        values.winningTerm === "point base" &&
        (!values.pointpool || (values.pointpool && values.pointpool.length < 1))
      ) {
        errMsg = "Please add point pool info!";
      } else if (values.pointpool.length > 0) {
        console.log('values.pointpool.length',values.pointpool.length)
        let pointPoolMsg = [], pointPoolPointsMsg = [];
        for (let j = 0; j < values.pointpool.length; j++) {
          if (
            parseInt(values.pointpool[j].rankFrom) >
            parseInt(values.pointpool[j].rankTo)
          ) {
            pointPoolMsg.push(true);
          } else {
            pointPoolMsg.push(false);
          }
          if (
            parseInt(values.pointpool[j].rankFrom) === 0 ||
            parseInt(values.pointpool[j].rankTo) === 0
          ) {
            pointPoolMsg.push(true);
          }
          if(!parseInt(values.pointpool[j].point) > 0){
            pointPoolPointsMsg.push(true);
          } else {
            pointPoolPointsMsg.push(false);
          }
        }

        if (pointPoolMsg.includes(true)) {
          errMsg = "Rank (To) should be more then Rank (From).";
        }
        if (pointPoolPointsMsg.includes(true)) {
          errMsg = "Point price should be more then Zero.";
        }
      } else if (
        (values.winningTerm === "rank" && !values.prizePooInfo) ||
        (values.prizePooInfo && values.prizePooInfo.length <= 0)
      ) {
        errMsg = "Please add prize pool info!";
      } else if (values.prizePoolInfo > 0) {
        let prizePoolInfoMsg = [];
        for (let j = 0; j < values.prizePoolInfo.length; j++) {
          if (
            parseInt(values.prizePoolInfo[j].rankFrom) >
            parseInt(values.prizePoolInfo[j].rankTo)
          ) {
            prizePoolInfoMsg.push(true);
          } else {
            prizePoolInfoMsg.push(false);
          }
        }

        if (prizePoolInfoMsg.includes(true)) {
          errMsg = "Rank (To) should be more then Rank (From).";
        }
      }
      setIsAddRound(false);
    }
    if (current === 3) {
      if (!values.rounds || (values.rounds && values.rounds.length === 0)) {
        errMsg = "Please add rounds!";
      } else if (values.rounds && values.rounds.length > 0) {
        let roundSavedCount = false;
        values.rounds.forEach((round, ind) => {
          if (!round.isSaved) {
            errMsg = `Please save the round ${ind + 1}!`;
            roundSavedCount = true;
          }
        });
        let checkFinalRound = values.rounds.filter((item) => {
          if (item.isFinalRound === "yes") {
            return item;
          }
        });
        if (checkFinalRound.length === 0 && !roundSavedCount) {
          errMsg = `Please add Final round!`;
        }
      }
    }
    if (current === 4) {
      companyInOutCurrency.forEach((euser, index) => {
        // console.log("euser.touranmentVisibility>>>",euser.touranmentVisibility)
        // if (!euser.touranmentVisibility) {
        //   errMsg = `Please select ${euser?.selectedCompany?.label}'s visibility`;
        //   return;
        // }
        if (!euser.touranmentStatus) {
          errMsg = `Please select ${euser?.selectedCompany?.label}'s status`;
          return;
        }
        if (!euser.isFeatured) {
          errMsg = `Please select ${euser?.selectedCompany?.label}'s is featured`;
          return;
        }
        if (
          !tableImage?.[euser?.selectedCompany?.value] ||
          !tableImage[euser?.selectedCompany?.value]
        ) {
          errMsg = `Please upload ${euser?.selectedCompany?.label}'s table image`;
          return;
        }
        
        if (
          !bannerImage?.[euser?.selectedCompany?.value] ||
          !bannerImage[euser?.selectedCompany?.value]
        ) {
          errMsg = `Please upload ${euser?.selectedCompany?.label}'s banner image`;
          return;
        }
        
        // if (
        //   !creatives.hasOwnProperty(euser?.selectedCompany?.value) ||
        //   !creatives[euser?.selectedCompany?.value]?.default
        // ) {
        //   errMsg = `Please upload ${euser?.selectedCompany?.label}'s creatives image`;
        //   return;
        // }
        if (
          !rules.hasOwnProperty(euser?.selectedCompany?.value) ||
          rules[euser?.selectedCompany?.value] === "" ||
          rules[euser?.selectedCompany?.value] === null
        ) {
          errMsg = `Please add ${euser?.selectedCompany?.label}'s rules`;
          return;
        }
        return;
      });
    }

    if (errMsg) {
      NotificationManager.error(errMsg, "Error");
      return false;
    } else {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
    setIsBtnDisable(false);
    // console.log("formIntialValue", frmInitialValues);
  };

  const onDateSet = (value, pData, values, setFieldValue) => {
    // console.log("pData", pData)
    // console.log("setFieldValue", setFieldValue)
    // console.log("values", values)
    // console.log("values", values)
    if (pData && pData.type === "start") {
      setStartDate(value);
      setFieldValue(startDate, value);
      // console.log("@@@@@@@@@@@@@1");
      let rounds = [...values.rounds];
      rounds.forEach((round, rind) => {
        // console.log("round", round);
        let item = { ...round };
        item.isSaved = false;
        rounds[rind] = item;
        setFieldValue("rounds", rounds);
        if (id) {
          setIsDateModified(true);
        } else {
          setIsDateModified(false);
        }
      });
    }
    //  console.log("after set date",new Date(values.startDate))
    if (pData && pData.type === "end") {
      setEndDate(value);
      setFieldValue(endDate, value, setFieldValue);
      // console.log("@@@@@@@@@@@@@2");
      let rounds2 = [...values.rounds];
      rounds2.forEach((round, rind) => {
        // console.log("round", round);
        let item2 = { ...round };
        item2.isSaved = false;
        rounds2[rind] = item2;
        setFieldValue("rounds", rounds2);
        if (id) {
          setIsDateModified(true);
        } else {
          setIsDateModified(false);
        }
      });
    }
  };

  const onGameTypeChange = (data, rulesData) => {
    // console.log("***************onGameTypeChange***************",data,rulesData)
    // console.log("***************onGameTypeChange*** rules************",rules)
    let tmpAry = {};
    rulesData?.length > 0 &&
      rulesData.forEach((compVal, comInd) => {
        // console.log("*********compVal", compVal)
        tmpAry[compVal?.companyId] = compVal?.rules || "";
      });

    setGameType(data);
    setRules(tmpAry);
  };

  const onGameChange = (data, values, setFieldValue) => {
    // console.log("******onGameChange*******", data, values, setFieldValue)
    let tmpAry = {};
    {
      companyInOutCurrency?.length > 0 &&
        companyInOutCurrency.forEach((compVal, comInd) => {
          tmpAry[compVal?.selectedCompany?.value] = data.settings.rules;
        });
    }
    setLastGame(data?._id || "");
    setRules(tmpAry);
    setGame(data);
    setMaps(data.settings.maps);
    setPerspectives(data.settings.perspectives);
    const titles = values.titles.map((item, ind) => {
      const newItem = {
        name:
          (data.settings.titles[ind] && data.settings.titles[ind].value) ||
          item.name,
        value: item.value || "",
        type:
          (data.settings.titles[ind] && data.settings.titles[ind].type) || "",
        isSelection:
          (data.settings.titles[ind] &&
            data.settings.titles[ind].isSelection) ||
          false,
        isContest:
          (data.settings.titles[ind] && data.settings.titles[ind].isContest) ||
          false,
        icon:
          (data.settings.titles[ind] && data.settings.titles[ind].icon) || "",
      };
      return newItem;
    });
    setFieldValue("titles", titles);
  };

  const onValuesChange = (e, values, setFieldValue) => {
    const name = e.target.name;
    // console.log("name", name);
    setFieldValue(e.target.name, e.target.value);

    if (
      (name === "totalPlayers" ||
        name === "entryFee" ||
        name === "killPoints") &&
      values.winningTerm === "point base"
    ) {
      const totalPlayers =
        name === "totalPlayers" ? e.target.value : values.totalPlayers;
      const entryFee = name === "entryFee" ? e.target.value : values.entryFee;
      const killPoints =
        name === "killPoints" ? e.target.value : values.killPoints;
      const platformFee =
        100 -
        (parseInt(killPoints) * parseInt(totalPlayers) * 100) /
          (parseInt(totalPlayers) * parseInt(entryFee));
      // const prizePool = parseInt(killPoints) * parseInt(totalPlayers);
      let prizePool = "";
      if (gameType?.name && gameType.name === "Squad") {
        prizePool = parseInt(killPoints) * parseInt(totalPlayers) * 4;
      } else if (gameType?.name && gameType.name === "Duo") {
        prizePool = parseInt(killPoints) * parseInt(totalPlayers) * 2;
      } else {
        prizePool = parseInt(killPoints) * parseInt(totalPlayers);
      }

      // console.log(
      //   "prizePool > 0 ? prizePool : 0",
      //   prizePool > 0 ? prizePool : 0,
      //   prizePool
      // );

      setFieldValue("platformFee", platformFee > 0 ? platformFee : 0);
      // setFieldValue("prizePool", prizePool > 0 ? prizePool : 0);
    }

    if (
      (name === "totalPlayers" ||
        name === "entryFee" ||
        name === "prizePool") &&
      values.winningTerm !== "point base"
    ) {
      const totalPlayers =
        name === "totalPlayers" ? e.target.value : values.totalPlayers;
      const entryFee = name === "entryFee" ? e.target.value : values.entryFee;
      const prizePool =
        name === "prizePool" ? e.target.value : values.prizePool;
      const platformFee =
        ((totalPlayers * entryFee - prizePool) * 100) /
        (totalPlayers * entryFee);
      setFieldValue("platformFee", platformFee > 0 ? platformFee : 0);
    }
  };

  const onPrizePoolChange = (e, values, setFieldValue) => {
    setFieldValue("prizePooInfo", []);
    setPrizePoolTypeListDropdownFilterData(values);
    setTotalWinners(0);
    setTotalPrize(0);
    setTotalAmount(0);
    if (values?.value && values.value === "amount") {
      setFieldValue("rewardDisplayText", "");
    }

    if (values?.value && values.value === "rewards") {
      setFieldValue("prizePool", "");
    }
  };

  const setTotalAmountWinner = (
    e,
    ind,
    values,
    setFieldValue,
    index,
    updatedPrizes
  ) => {
    const name = e.target.name;
    setFieldValue(e.target.name, e.target.value);

    const rankFrom =
      name === `prizePooInfo[${ind}].rankFrom`
        ? e.target.value
        : values.prizePooInfo[ind].rankFrom;
    const rankTo =
      name === `prizePooInfo[${ind}].rankTo`
        ? e.target.value
        : values.prizePooInfo[ind].rankTo;

    const prize =
      name === `prizePooInfo[${ind}].prize`
        ? e.target.value
        : values.prizePooInfo[ind].prize;

    setFieldValue(`prizePooInfo[${ind}].prize`, prize);

    const amount =
      name === `prizePooInfo[${ind}].amount`
        ? e.target.value
        : values.prizePooInfo[ind].amount;

    let totalWinner = values.totalWinners;
    let prizePooInfo = values.prizePooInfo;

    if (parseInt(rankFrom) <= 0) {
      NotificationManager.error("Rank Should not be zero", "Error");
      setFieldValue(e.target.name, 0);
      return false;
    }

    if (parseInt(rankFrom) > parseInt(totalWinner)) {
      NotificationManager.error(
        "Rank Should not be more than Total Winners",
        "Error"
      );
      setFieldValue(e.target.name, 0);
      return false;
    }

    if (rankTo > parseInt(totalWinner)) {
      NotificationManager.error(
        "Rank To should not be more than Total Winners",
        "Error"
      );
      setFieldValue(e.target.name, 0);
      return false;
    }

    let totUser = parseInt(rankTo) - parseInt(rankFrom) + 1;

    setFieldValue(
      `prizePooInfo[${ind}].totalAmount`,
      parseInt(totUser * amount)
    );

    let totalAmount = 0;
    let totalWinners = 0;
    let prizeSum = 0;

    prizePooInfo.forEach((item, index) => {
      let rF = item.rankFrom;
      let rT = item.rankTo;
      let pP = item.prize;
      let aT = Number(item.totalAmount);

      if (ind === index) {
        rF = parseInt(rankFrom);
        rT = parseInt(rankTo);
        aT = parseInt(totUser * amount);
        pP = parseInt(prize);
      }

      if (parseInt(rT) >= parseInt(rF)) {
        totalWinners += parseInt(rT) - parseInt(rF) + 1;
      } else {
        totalWinners++;
      }

      if (pP) {
        prizeSum += pP;
      }

      if (aT) {
        totalAmount += aT;
      }
    });

    setTotalPrize(prizeSum);
    setTotalAmount(totalAmount);
    setTotalWinners(totalWinners);
  };

  const setPointPrizePool = (e, ind, values, setFieldValue) => {
    const name = e.target.name;
    setFieldValue(e.target.name, e.target.value);

    const rankFrom =
      name === `pointpool[${ind}].rankFrom`
        ? e.target.value
        : values.pointpool[ind].rankFrom;
    const rankTo =
      name === `pointpool[${ind}].rankTo`
        ? e.target.value
        : values.pointpool[ind].rankTo;
    let totalWinner = values.totalWinners;
    let pointPoolInfo = values.pointpool;

    if (parseInt(rankFrom) <= 0) {
      NotificationManager.error("Rank Should not be zero", "Error");
      setFieldValue(e.target.name, 0);
      return false;
    }
    // if (parseInt(rankFrom) > parseInt(totalWinner)) {
    //   NotificationManager.error(
    //     "Rank Should not more than Total Winners",
    //     "Error"
    //   );
    //   setFieldValue(e.target.name, 0);
    //   return false;
    // }
    // if (rankTo > parseInt(totalWinner)) {
    //   NotificationManager.error(
    //     "Rank Should not more than Total Winners",
    //     "Error"
    //   );
    //   setFieldValue(e.target.name, 0);
    //   return false;
    // }

    let totalWinners = 0;
    pointPoolInfo.forEach((item, index) => {
      let rF = item.rankFrom;
      let rT = item.rankTo;
      if (ind === index) {
        rF = parseInt(rankFrom);
        rT = parseInt(rankTo);
      }

      if (parseInt(rF) === 0 && parseInt(rT) > 0) {
        totalWinners++;
      } else if (parseInt(rT) === parseInt(rF)) {
        totalWinners++;
      } else if (parseInt(rT) > parseInt(rF)) {
        totalWinners += parseInt(rT) - parseInt(rF) + 1;
      } else if (parseInt(rF) > parseInt(rT)) {
        totalWinners++;
      }
    });
    setTotalPointWinners(totalWinners);
  };

  const removePointPoolInfo = (ind, values, setFieldValue) => {
    const rankFrom = values.pointpool[ind].rankFrom;
    const rankTo = values.pointpool[ind].rankTo;
    let totalWinner = values.totalWinners;
    let pointPoolInfo = values.pointpool;

    let totalWinners = 0;
    pointPoolInfo.map((item, index) => {
      if (index !== ind) {
        let rF = item.rankFrom;
        let rT = item.rankTo;
        if (parseInt(rF) === 0 && parseInt(rT) > 0) {
          totalWinners++;
        } else if (parseInt(rT) === parseInt(rF)) {
          totalWinners++;
        } else if (parseInt(rT) > parseInt(rF)) {
          totalWinners += parseInt(rT) - parseInt(rF) + 1;
        } else if (parseInt(rF) > parseInt(rT)) {
          totalWinners++;
        }
      }
    });

    const temp = [...pointPoolInfo];
    temp.splice(ind, 1);

    setTotalPointWinners(totalWinners);

    setFieldValue(`pointpool`, temp);
  };

  const removePrizePoolInfo = (ind, values, setFieldValue) => {
    const rankFrom = values.prizePooInfo[ind].rankFrom;
    const rankTo = values.prizePooInfo[ind].rankTo;
    const amount = values.prizePooInfo[ind].amount;
    let prizePoolInfo = values.prizePooInfo.slice(); // Using slice() to create a shallow copy of the array

    let totUser = 0;
    if (parseInt(rankFrom) < parseInt(rankTo)) {
      totUser = parseInt(rankTo) - parseInt(rankFrom) + 1;
    } else {
      totUser = 1;
    }

    let totalAmount = 0;
    let totalWinners = 0;
    let prizeSum = 0;

    prizePoolInfo = prizePoolInfo.filter((item, index) => {
      if (index !== ind) {
        let rF = item.rankFrom;
        let rT = item.rankTo;
        let pP = item.prize;
        let aT = Number(item.totalAmount);

        if (parseInt(rT) >= parseInt(rF)) {
          totalWinners += parseInt(rT) - parseInt(rF) + 1;
        } else {
          totalWinners++;
        }

        if (pP) {
          prizeSum += pP;
        }

        if (aT) {
          totalAmount += aT;
        }

        return true; // Keep the item in the array
      }
      return false; // Exclude the item at the specified index
    });

    setTotalPrize(prizeSum);
    setTotalAmount(totalAmount);
    setTotalWinners(totalWinners);

    setFieldValue(`prizePooInfo`, prizePoolInfo);
  };

  const ResetRoundAdd = (values, ind, setFieldValue) => {
    let rounds = [...values.rounds];
    if (ind === rounds.length - 1) {
      setIsAddRound(false);
      let item = { ...rounds[ind] };
      item.isSaved = false;
      rounds[ind] = item;
      setFieldValue("rounds", rounds);
    } else {
      NotificationManager.error(
        "Please remove round " + (ind + 2) + " first!",
        "Error"
      );
      return false;
    }
  };

  const removeRound = (arrayHelpers, rind, values, setFieldsValue) => {
    arrayHelpers.remove(rind);
    setIsAddRound(true);
  };

  const MakeIsRoundAdd = (values, ind, setFieldValue) => {
    // console.log("round-data", values.startDate);
    let startDT = new Date(values.startDate);
    // console.log("round-data", startDT);

    let rounds = [...values.rounds];
    let totalPlayers = values.totalPlayers;
    let item = { ...rounds[ind] };
    if (!item.name) {
      NotificationManager.error(`please add round ${ind + 1} name!`, "Error");
      return;
    } else if (!item.matches || (item.matches && item.matches.length === 0)) {
      NotificationManager.error(`please add round ${ind + 1} match!`, "Error");
      return;
    } else if (item.matches && item.matches.length > 0) {
      let errMsg = "";
      item.matches.forEach((match, mind) => {
        if (!match.date) {
          errMsg = `please add round ${ind + 1} match ${mind + 1} date!`;
          return;
        } else {
          // console.log("&&&&&&&&&&&&&&&match", match);
          const d1 = new Date(match.date); // Date object with date from d1
          const d2 = new Date(match.time);
          // console.log(startDT);
          const year = d1.getFullYear();
          const month = d1.getMonth();
          const day = d1.getDate();
          const hours = d2.getHours();
          const minutes = d2.getMinutes();
          const seconds = d2.getSeconds();
          const milliseconds = d2.getMilliseconds();
          const combinedDate = new Date(
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
            milliseconds
          );
          const timestamp = combinedDate.getTime();
          // console.log(
          //   "---------------------------->",
          //   timestamp,
          //   startDT,
          //   timestamp < startDT
          // );
          if (timestamp < startDT) {
            // console.log("match.date < values.startDate::if");
            errMsg = `Please select valid date for round ${ind +
              1} (Date should after StartDate)`;
            //NotificationManager.error( `please select valid date for ${ind + 1} match ${mind + 1}`, 'Error');
            return;
          }
          if (mind > 0) {
            // console.log("mind>0::if");
            item.matches.forEach((match2, mind2) => {
              //console.log(`compair date ${new Date(match2.time)} and ${new Date(match.date)}`,new Date(match2.time) >= new Date(match.time));
              const d11 = new Date(match2.date); // Date object with date from d1
              const d12 = new Date(match2.time);
              // console.log(timestamp);
              const year1 = d11.getFullYear();
              const month1 = d11.getMonth();
              const day1 = d11.getDate();
              const hours1 = d12.getHours();
              const minutes1 = d12.getMinutes();
              const seconds1 = d12.getSeconds();
              const milliseconds1 = d12.getMilliseconds();
              const combinedDate1 = new Date(
                year1,
                month1,
                day1,
                hours1,
                minutes1,
                seconds1,
                milliseconds1
              );
              const timestamp1 = combinedDate1.getTime();

              // if (mind > mind2 && timestamp1 >= timestamp) {
              //   console.log(" mind > mind2 && timestamp1 >= timestamp");
              //   errMsg = `Match R${ind + 1}M${mind +
              //     1} date should after R${ind + 1}M${mind2 + 1} `;
              //   NotificationManager.error(`Match ${match.matchId} date should after${match2.matchId} `, 'Error');
              //   return;
              // }
            });
          } else {
            // console.log("######")
          }
        }
        if (!match.time) {
          errMsg = `please add round ${ind + 1} match ${mind + 1} time!`;
          return;
        }
        if (!match.userCount) {
          errMsg = `please add round ${ind + 1} match ${mind + 1} user!`;
          return;
        }
        if (!match.winnerCount) {
          errMsg = `please add round ${ind + 1} match ${mind + 1} winner!`;
          return;
        }
      });
      if (errMsg) {
        NotificationManager.error(errMsg, "Error");
        return false;
      } else {
        //  console.log("######3")
      }
    }
    if (ind != 0 && ind > 0) {
      let errMsg = "";
      rounds.forEach((round, rind) => {
        round.matches.forEach((match, mind) => {
          const d21 = new Date(match.date); // Date object with date from d1
          const d22 = new Date(match.time);
          //console.log(startDT);
          const year2 = d21.getFullYear();
          const month2 = d21.getMonth();
          const day2 = d21.getDate();
          const hours2 = d22.getHours();
          const minutes2 = d22.getMinutes();
          const seconds2 = d22.getSeconds();
          const milliseconds2 = d22.getMilliseconds();
          const combinedDate2 = new Date(
            year2,
            month2,
            day2,
            hours2,
            minutes2,
            seconds2,
            milliseconds2
          );
          const timestamp2 = combinedDate2.getTime();
          rounds[ind].matches.forEach((match2, mind2) => {
            if (ind !== rind) {
              const d31 = new Date(match2.date); // Date object with date from d1
              const d32 = new Date(match2.time);
              // console.log(timestamp2);
              const year3 = d31.getFullYear();
              const month3 = d31.getMonth();
              const day3 = d31.getDate();
              const hours3 = d32.getHours();
              const minutes3 = d32.getMinutes();
              const seconds3 = d32.getSeconds();
              const milliseconds3 = d32.getMilliseconds();
              const combinedDate3 = new Date(
                year3,
                month3,
                day3,
                hours3,
                minutes3,
                seconds3,
                milliseconds3
              );
              const timestamp3 = combinedDate3.getTime();
              // if (timestamp3 <= timestamp2) {
              //   errMsg = `Match R${ind + 1}M${mind2 +
              //     1} date should after R${rind + 1}M${mind + 1} `;
              //   // NotificationManager.error(`Match R${rind + 1}M${mind + 1} date should after R${rind + 1}M${mind2 + 1} `, 'Error');
              //   return;
              // } else {
              //   //  console.log("######9")
              // }
            } else {
              //  console.log("######$")
            }
          });
        });
      });
      if (errMsg) {
        NotificationManager.error(errMsg, "Error");
        return false;
      }
    }

    if (ind === 0) {
      let totalUser = 0;
      if (rounds[ind] && rounds[ind].matches) {
        rounds[ind].matches.forEach((match) => {
          if (match && match.userCount) {
            totalUser += parseInt(match.userCount);
          }
        });
      }

      if (totalPlayers && parseInt(totalUser) !== parseInt(totalPlayers)) {
        NotificationManager.error("Total users does not matched!", "Error");
        return false;
      }
    } else {
      let preRoundMLeangth = rounds[ind - 1].matches.length;
      let contests = [];
      rounds[ind].matches.forEach(
        (item) => (contests = [...contests, ...item.contest])
      );
      if (contests.length !== preRoundMLeangth) {
        NotificationManager.error(
          "Please select all matches or previews round!",
          "Error"
        );
        return false;
      }
    }
    // let item = { ...rounds[ind] };
    item.isSaved = true;
    let matches = [...item.matches];
    let newmatches = matches.map((match, mind) => {
      let newMatch = { ...match };
      newMatch.matchId = `R${ind + 1}M${mind + 1}`;
      return newMatch;
    });
    item.matches = newmatches;
    rounds[ind] = item;
    setFieldValue("rounds", rounds);
    setIsAddRound(true);
    if (rounds[ind] && rounds[ind]["isFinalRound"] === "yes") {
      setIsBtnDisable(false);
      setIsAddRound(false);
    }
  };

  const ContestsMultiSelectOptions = (rind, rmind, values) => {
    // return [] ;
    const ind = rind;
    // const ind2 = rmind;
    let rounds = values.rounds;
    const newInd = ind !== 0 ? parseInt(ind - 1) : parseInt(0);
    let options = [];
    if (rounds[newInd] && rounds[newInd].matches) {
      let matches = rounds[newInd].matches;
      matches.forEach((match, index) => {
        options.push(match.matchId);
      });
      let currentMatches = [];
      rounds[rind].matches.forEach((item) => {
        if (item.contest) {
          // currentMatches.push(item.contest);
          currentMatches = [...currentMatches, ...item.contest];
        }
      });

      options = options.filter((item) => !currentMatches.includes(item));
    }

    return options;
  };

  const selectedContest = (value, rind, rmind, values, setFieldValue) => {
    let rounds = JSON.parse(JSON.stringify(values.rounds));
    let noOfUser = 0;
    if (value && rounds) {
      rounds.map((round, index) => {
        round.matches.forEach((match, index2) => {
          if (value.includes(match.matchId)) {
            noOfUser += parseInt(match.winnerCount);
          }
        });
        return round;
      });
      if (noOfUser > 0) {
        let item = { ...rounds[rind].matches[rmind] };
        item.contest = value;
        item.userCount = noOfUser;
        rounds[rind].matches[rmind] = item;
      }
      setFieldValue("rounds", rounds);
    }
  };

  const matchDate = (e, rind, rmind, values, setFieldValue) => {
    setFieldValue(`rounds[${rind}].matches[${rmind}].date`, e?.date);
  };

  const matchTime = (e, rind, rmind, values, setFieldValue) => {
    setFieldValue(`rounds[${rind}].matches[${rmind}].time`, e?.date);
  };

  const getminDate = (rind, rmind, values) => {
    if (rind === 0 && rmind === 0) {
      return moment(values.startDate);
    } else {
      let mindate = moment(values.startDate);
      if (rmind === 0) {
        const mlength = values.rounds[rind - 1].matches.length;
        if (values.rounds[rind - 1].matches[mlength - 1].date) {
          mindate = moment(values.rounds[rind - 1].matches[mlength - 1].date);
        }
      } else {
        if (values.rounds[rind].matches[rmind - 1].date) {
          mindate = moment(values.rounds[rind].matches[rmind - 1].date);
        }
      }
      return mindate;
    }
  };

  const validateRoundUser = (e, rind, rmind, values, setFieldValue) => {
    const name = e.target.name;
    setFieldValue(e.target.name, e.target.value);
    const userCount = e.target.value;
    const totalPlayers = values.totalPlayers;
    if (parseInt(userCount) > parseInt(totalPlayers)) {
      setFieldValue(name, 0);
      NotificationManager.error(
        "Total User is not more than Total players",
        "Error"
      );
      return;
    }
  };

  const checkWinnerValue = (e, rind, rmind, values, setFieldValue) => {
    const name = e.target.name;
    setFieldValue(e.target.name, e.target.value);
    let rounds = [...values.rounds];
    const userCount = rounds[rind].matches[rmind]["userCount"] || 0;
    const winnerCount = e.target.value;
    if (parseInt(winnerCount) > parseInt(userCount)) {
      setFieldValue(name, 0);
      NotificationManager.error(
        "Total Winner is not more than Total user",
        "Error"
      );
      return;
    }
  };

  const GetTotalUser = ({ ind, type, values }) => {
    let rounds = [...values.rounds];
    let totalUser = 0;
    let totalWinner = 0;
    if (rounds[ind] && rounds[ind].matches) {
      rounds[ind].matches.forEach((match) => {
        if (match && match.userCount) {
          totalUser += parseInt(match.userCount);
        }
        if (match && match.winnerCount) {
          totalWinner += parseInt(match.winnerCount);
        }
      });
    }
    if (type === "totalUser") {
      return totalUser;
    }
    if (type === "totalWinner") {
      return totalWinner;
    }
  };

  const onIsSharedValuesChange = (e, values, setFieldValue) => {
    if (
      (e.target.name === "isShared" && e.target.value === true) ||
      e.target.value === "true"
    ) {
      let filterCond = {};
      filterCond.search = {};
      filterCond.search.isShared = true;

      dispatch(actions.fetchCompanyDropdownList(filterCond));
    } else {
      dispatch(actions.fetchCompanyDropdownList());
    }

    setFieldValue(e.target.name, e.target.value);
    setCompanyInOutCurrency([
      {
        companyId: "",
        inCurrency: "",
        outCurrency: "",
        companyCurrency: [],
        selectedCompany: null,
        touranmentVisibility: "portal",
        touranmentStatus: "true",
        isFeatured: "false",
      },
    ]);

    setCurrencyWiseCompanyListDropdownFilterData([]);
  };

  const setTimeing = (value, type, ind) => {
    let tempArray = [...companyInOutCurrency];
    let tempGameTypes = { ...tempArray[ind] };
    tempGameTypes[type] = value;
    tempArray[ind] = tempGameTypes;
    setCompanyInOutCurrency(tempArray);
  };
  const uploadImage = (event, companyId = "", name) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
  
    dispatch(actions.uploadImage({ img: file, name })).then((success) => {
      const uploaded = success?.entities;
      const fullUrl = imageUrl(uploaded?.default); // ✅ Full S3 path
  
      if (!fullUrl) return; // Prevent setting undefined URLs
  
      switch (name) {
        case "eventTableImage":
          setTableImage((prev) => ({
            ...prev,
            [companyId]: fullUrl,
          }));
          break;
  
        case "bannerImage":
          setBannerImage((prev) => ({
            ...prev,
            [companyId]: fullUrl,
          }));
          break;
  
        case "creatives":
          setCreatives((prev) => ({
            ...prev,
            [companyId]: fullUrl,
          }));
          break;
  
        case "featuredImage":
          setFeaturedImage({
            default: uploaded?.default, // only filename, not full path
          });
          break;
  
        default:
          console.warn("Unknown image type:", name);
      }
    });
  };
  
  
  // const setTableImageFun = (value, _idof) => {
  //   setTableImage((oldState) => ({ ...oldState, [_idof]: value?.image }));
  // };
// for build
  const setTableImageFun = (value, _idof) => {
    setTableImage((oldState) => ({ ...oldState, [_idof]: value?.image }));
  };

  const setBannerImageFun = (value, _idof) => {
    setBannerImage((oldState) => ({ ...oldState, [_idof]: value?.image }));
  };

  const setCreativesImageFun = (value, _idof) => {
    setCreatives((oldState) => ({ ...oldState, [_idof]: value?.image }));
  };

  const setRulesValue = (_idof, evt) => {
    //console.log("*********setRulesValue**************",_idof,evt)
    const newContent = evt.editor.getData();
    setRules((oldState) => ({ ...oldState, [_idof]: newContent }));
  };

  const saveTournament = (values) => {
    if (clickCheck) {
      NotificationManager.error("Don't Submit Twice same Tournament", "Error");
    } else {
      setClickCheck(true);
      setIsLoading(true);

      // console.log("final submit value", values)
      values.isVisible = values.isVisible;
      values.isFeatured = values.isFeatured;
      values.isPrivate = values.isVisible;
      values.isShared = values.isShared;
      values.isConfirmStatus = values.isConfirmStatus;
      values.isCustomRank = costumRank;

      // if(values.winningTerm ==="rank"){
      //   values.isCustomRank= true
      // }else {
      //   values.isCustomRank= false
      // }

      if (countrySelectedDropdownFilterData.length > 0) {
        let req_country = [];
        for (let i = 0; i < countrySelectedDropdownFilterData.length; i++) {
          req_country.push(countrySelectedDropdownFilterData[i].value);
        }
        values.countries = req_country;
      }
      values.contestFor = companyInOutCurrency;
      values.game = game?._id || values.game;
      values.gameType = gameType?._id || values.gameType;
      values.prizePoolType =
        prizePoolTypeSelectedDropdownFilterData?.value || values.prizePoolType;
      // values.prizePooInfo.forEach((info, index) => {
      //   info.prize = enteredPrizes[index];
      // });

      // values.prizePooInfo = values.prizePooInfo.map((info, index) => {
      //   console.log('Mapping prize for index', index, 'with value:', enteredPrizes[index]);
      //   console.log('enteredPrizes:', enteredPrizes);
      //   return {
      //     ...info,
      //     prize: enteredPrizes[index],
      //   };
      // });

      // console.log("prizeeeeeee", values.prizePooInfo)
      // values.eventTableImage = tableImage[value?.selectedCompany?.value];
      values.eventTableImage = Object.keys(tableImage).map((companyId) => ({
        company: companyId,
        eventTableImage: tableImage[companyId],
      }));
      values.creatives = creatives;
      values.bannerImage = bannerImage;
      values.featuredImage = featuredImage;
      values.rules = Object.keys(rules).map((companyId) => ({
        company: companyId,
        rules: rules[companyId],
      }));
      // console.log("final submit value winningTerm", values.winningTerm, values.isCustomRank)
      if (!id) {
        dispatch(actions.createItem(values)).then((sucess) => {
          setIsLoading(false); // Set loading state to false after API call
          if (sucess) {
            backToList();
            setClickCheck(false);
          } else {
            setClickCheck(false);
          }
        });
      } else {
        dispatch(actions.updateItem(values)).then((sucess) => {
          setIsLoading(false); // Set loading state to false after API call
          if (sucess) {
            backToList();
            setClickCheck(false);
          } else {
            setClickCheck(false);
          }
        });
      }
    }
  };

  const gamerjiViewItem = () => {
    const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/create`;
    window.open(url, "_blank");
  };

  return (
    <Card>
      {/* <CardHeader title={title}></CardHeader> */}
      <CardBody className="p-0">
        <NotificationContainer />
        <div className="wizard wizard-4">
          <div className="wizard-nav border-right">
            <div className="wizard-steps">
              {steps.map((item, ind) => (
                // <Step key={item.title} title={item.title} />
                <div
                  style={{ width: `${parseFloat(100 / steps.length, 1)}%` }}
                  next
                  key={item.title}
                  className={
                    current === ind ? "current wizard-step" : "wizard-step"
                  }
                >
                  <div className="wizard-wrapper">
                    <div className="wizard-number">{ind + 1}</div>
                    <div className="wizard-label">
                      <div className="wizard-title">{item.title}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="wizard-body px-8 py-8">
            <div className="row">
              <Formik
                enableReinitialize={true}
                initialValues={frmInitialValues}
                // validationSchema={next}
                onSubmit={(values) => {
                  saveTournament(values);
                }}
              >
                {({
                  handleSubmit,
                  errors,
                  values,

                  setFieldValue,
                  validateField,
                  validateForm,
                }) => (
                  <Form className="form form-label-right w-100">
                    {steps[current].code === "generalStep" && (
                      <div className="offset-xxl-2 col-xxl-8">
                        <h4 className="mb-10 font-weight-bold text-dark">
                          Setup Your {steps[current].title}
                        </h4>
                        <div
                          className="pb-5 row d-flex"
                          data-wizard-type="step-content"
                          data-wizard-state="current"
                        >
                          <div className="col-lg-6">
                            <label>Select Countries</label>
                            <DropdownReactSelect
                              placeholder={"Country..."}
                              name={"game"}
                              value={countrySelectedDropdownFilterData}
                              isClearable={true}
                              isMulti={true}
                              isSearchable={true}
                              closeMenuOnSelect={true}
                              options={countryDropdownFilterData}
                              onChange={setCountryListDropdownFilterData}
                              isDisabled={values?.totalJoinedPlayers >= 1}
                            />
                          </div>
                          <div className="col-lg-6">
                            <Field
                              name="title"
                              component={Input}
                              placeholder="Title"
                              label="Title"
                              disabled={values?.totalJoinedPlayers >= 1}
                            />
                          </div>
                          <div className="col-lg-6">
                            <Field
                              name="slogan"
                              component={Input}
                              placeholder="Slogan"
                              label="Slogan"
                              disabled={values?.totalJoinedPlayers >= 1}
                            />
                          </div>
                          <div className="col-lg-6">
                            <Field
                              name="descriptions"
                              type="textarea"
                              component={Input}
                              placeholder="Description"
                              label="Description"
                              disabled={values?.totalJoinedPlayers >= 1} // Disable if totalJoinedPlayers is 1 or more
                            />
                          </div>

                          <div className="col-lg-6">
                            <DatePickerField
                              label="Start Date Time"
                              name="startDate"
                              format={"YYYY-MM-DD hh:mm a"}
                              minDate={moment().format("YYYY-MM-DD")}
                              type={"start"}
                              date={
                                values.startDate && moment(values.startDate)
                              }
                              onDateSet={(value, pdata) =>
                                onDateSet(value, pdata, values, setFieldValue)
                              }
                            />
                          </div>

                          <div className="col-lg-6">
                            <DatePickerField
                              label="End Date Time"
                              name="endDate"
                              format={"YYYY-MM-DD hh:mm a"}
                              // minDate={minDate}
                              minDate={moment().format("YYYY-MM-DD")}
                              type={"end"}
                              date={values.endDate && moment(values.endDate)}
                              onDateSet={(value, pdata) =>
                                onDateSet(value, pdata, values, setFieldValue)
                              }
                            />
                          </div>

                          {/* currencyType */}
                          <div className="col-lg-4">
                            <div
                              role="group"
                              aria-labelledby="my-radio-group"
                              className="radio-inline"
                            >
                              <label className="mr-3 w-100 p-0">
                                WinningTerm :{" "}
                              </label>
                              <label className="radio my-radio-btn">
                                <Field
                                  type="radio"
                                  name="winningTerm"
                                  value={"rank"}
                                  disabled={values?.totalJoinedPlayers >= 1}
                                />
                                <span></span>Rank
                              </label>
                              <label className="radio my-radio-btn">
                                <Field
                                  type="radio"
                                  name="winningTerm"
                                  value={"point base"}
                                  disabled={values?.totalJoinedPlayers >= 1}
                                />
                                <span></span>Point Base
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div
                              role="group"
                              aria-labelledby="my-radio-group"
                              className="radio-inline"
                            >
                              <label className="mr-3 col-12 p-0">
                                Visibility :{" "}
                              </label>
                              <label className="radio my-radio-btn">
                                <Field
                                  type="radio"
                                  name="isVisible"
                                  value={"true"}
                                />
                                <span></span>Public
                              </label>
                              <label className="radio my-radio-btn">
                                <Field
                                  type="radio"
                                  name="isVisible"
                                  value={"false"}
                                />
                                <span></span>Private
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div
                              role="group"
                              aria-labelledby="my-radio-group"
                              className="radio-inline"
                            >
                              <label className="mr-3 col-12 p-0">
                                Custom Rank :{" "}
                              </label>
                              <label className="radio my-radio-btn">
                                <Field
                                  type="radio"
                                  name="isCustomRank"
                                  value={"true"}
                                  checked={
                                    values?.winningTerm === "rank" || false
                                  }
                                  disabled={
                                    values?.totalJoinedPlayers >= 1 ||
                                    values?.winningTerm === "rank"
                                  }
                                />
                                <span></span>Yes
                              </label>
                              <label className="radio my-radio-btn">
                                <Field
                                  type="radio"
                                  name="isCustomRank"
                                  value={"false"}
                                  checked={
                                    values?.winningTerm !== "rank" || false
                                  }
                                  // checked={values?.winningTerm !== "rank"}
                                  disabled={
                                    values?.totalJoinedPlayers >= 1 ||
                                    values?.winningTerm === "rank"
                                  }
                                />
                                <span></span>No
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div
                              role="group"
                              aria-labelledby="my-radio-group"
                              className="radio-inline"
                            >
                              <label className="mr-3 col-12 p-0">
                                Is Shared :{" "}
                              </label>
                              <label className="radio my-radio-btn">
                                <Field
                                  type="radio"
                                  name="isShared"
                                  value={"true"}
                                  onChange={(e) =>
                                    onIsSharedValuesChange(
                                      e,
                                      values,
                                      setFieldValue
                                    )
                                  }
                                  disabled={values?.totalJoinedPlayers >= 1}
                                />
                                <span></span>Yes
                              </label>
                              <label className="radio my-radio-btn">
                                <Field
                                  type="radio"
                                  name="isShared"
                                  value={"false"}
                                  onChange={(e) =>
                                    onIsSharedValuesChange(
                                      e,
                                      values,
                                      setFieldValue
                                    )
                                  }
                                  disabled={values?.totalJoinedPlayers >= 1}
                                />
                                <span></span>No
                              </label>
                            </div>
                          </div>

                          {companyInOutCurrency.map(
                            (comInOutCurrencyVal, comInOutCurrencyInd) => {
                              return (
                                <>
                                  <div
                                    className="col-md-12 d-flex p-0"
                                    key={comInOutCurrencyInd}
                                  >
                                    <div className="col-lg-4 mb-4">
                                      <label>Select Company</label>
                                      <DropdownReactSelect
                                        placeholder={"Company"}
                                        name={"company"}
                                        value={
                                          comInOutCurrencyVal?.selectedCompany
                                        }
                                        isMulti={false}
                                        isClearable={false}
                                        isSearchable={true}
                                        closeMenuOnSelect={true}
                                        isDisabled={
                                          values?.totalJoinedPlayers >= 1
                                        }
                                        // options={contestForDropdownFilterData}
                                        options={contestForDropdownFilterData.map(
                                          (v) => ({
                                            ...v,
                                            index: comInOutCurrencyInd,
                                          })
                                        )}
                                        onChange={
                                          onChangeContestForListDropdownFilterData
                                        }
                                      />
                                    </div>

                                    <div className="col-lg-3 mb-4">
                                      <label>In Currency</label>
                                      <DropdownReactSelect
                                        placeholder={"In Currency..."}
                                        name={"inCurrency"}
                                        value={comInOutCurrencyVal?.inCurrency}
                                        isMulti={false}
                                        isClearable={false}
                                        isSearchable={true}
                                        isDisabled={
                                          values?.totalJoinedPlayers >= 1
                                        }
                                        closeMenuOnSelect={true}
                                        options={comInOutCurrencyVal?.companyInOutCurrency?.map(
                                          (v) => ({
                                            ...v,
                                            index: comInOutCurrencyInd,
                                            cType: "in",
                                          })
                                        )}
                                        onChange={onChangeInOutCurrency}
                                      />
                                    </div>

                                    <div className="col-lg-3 mb-4">
                                      <label>Out Currency</label>
                                      <DropdownReactSelect
                                        placeholder={"Out Currency..."}
                                        name={"outCurrency"}
                                        value={comInOutCurrencyVal?.outCurrency}
                                        isMulti={false}
                                        isClearable={false}
                                        isSearchable={true}
                                        closeMenuOnSelect={true}
                                        isDisabled={
                                          values?.totalJoinedPlayers >= 1
                                        }
                                        options={comInOutCurrencyVal?.companyInOutCurrency?.map(
                                          (v) => ({
                                            ...v,
                                            index: comInOutCurrencyInd,
                                            cType: "out",
                                          })
                                        )}
                                        onChange={onChangeInOutCurrency}
                                      />
                                    </div>
                                    {console.log(values?.totalJoinedPlayers)}
                                    {(values.isShared == "true" || values.isShared == true) && (values?.totalJoinedPlayers === 0 || values?.totalJoinedPlayers === undefined) ? ( // GJSAAS-2514 Fixed the issue by jaimin
                                      <>
                                        <div
                                          className="col-lg-1"
                                          style={{ marginTop: "24px" }}
                                        >
                                          {comInOutCurrencyInd !== 0 && (
                                            <button
                                              type="button"
                                              className="btn btn-danger ml-2"
                                              onClick={() =>
                                                removeTechInput(
                                                  comInOutCurrencyInd
                                                )
                                              }
                                            >
                                              <i className="ki ki-minus"></i>
                                            </button>
                                          )}
                                        </div>
                                        <div
                                          className="col-lg-1"
                                          style={{ marginTop: "24px" }}
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-dark ml-2"
                                            onClick={() => addInput()}
                                          >
                                            <i className="ki ki-plus"></i>
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </>
                              );
                            }
                          )}

{/* Featured Image Upload */}
<div className="col-md-4 mt-4">
  <label>Featured Image</label>
  <input
    name="featuredImage"
    type="file"
    className="form-control"
    label="Featured Image"
    accept=".png, .jpg, .jpeg"
    onChange={(e) => uploadImage(e, "", "featuredImage")}
  />
</div>

{/* Featured Image Preview */}
<div className="col-md-8 mt-4 offset-md-2">
  <div className="row d-flex" style={{ justifyContent: "center" }}>
    <div className="col-md-4 mt-4">
      {featuredImage?.default && (
        <div className="thumb-image-display">
          <img
            src={imageUrl(featuredImage.default)}
            style={{ width: "100%" }}
            alt="Featured Preview"
          />
        </div>
      )}
      
    </div>
  </div>
</div>


                        </div>
                      </div>
                    )}

                    {steps[current].code === "gameStep" && (
                      <div className="offset-xxl-2 col-xxl-8">
                        <div
                          className="pb-5"
                          data-wizard-type="step-content"
                          data-wizard-state="current"
                        >
                          <h4 className="mb-10 font-weight-bold text-dark">
                            Setup Your {steps[current].title}
                          </h4>
                          <div className="d-flex flex-fill flex-wrap">
                            {/* mohit */}
                            <Field
                              name="game"
                              component={GameSelectInput}
                              placeholder="Game"
                              label="Game"
                              source="game"
                              // onSelect={data => onGameChange(data, values, setFieldValue)}
                              onSelect={(data) => {
                                if (
                                  lastSelectedGame != "" &&
                                  lastSelectedGame.toString() !=
                                    data?._id.toString()
                                ) {
                                  values.gameType = "";
                                  values.titles = [
                                    {
                                      name: "title1",
                                      value: "",
                                      isContest: true,
                                      isSelection: false,
                                    },
                                    {
                                      name: "title2",
                                      value: "",
                                      isContest: true,
                                      isSelection: false,
                                    },
                                    {
                                      name: "title3",
                                      value: "",
                                      isContest: true,
                                      isSelection: false,
                                    },
                                    {
                                      name: "title4",
                                      value: "",
                                      isContest: true,
                                      isSelection: false,
                                    },
                                  ];
                                }
                                onGameChange(data, values, setFieldValue);
                              }}
                              filter={{
                                search: {
                                  company: currencyWiseCompanySelectedDropdownFilterData,
                                  countries: countrySelectedDropdownFilterData,
                                },
                                pagination: { recordPerPage: 1000000 },
                              }}
                            />
                          </div>
                          {values.game && (
                            <div className="d-flex flex-fill flex-wrap">
                              <Field
                                name="gameType"
                                component={GameSelectInput}
                                placeholder="Game Type"
                                label="Game Type"
                                source="gameType"
                                onSelect={(data, rulesData) =>
                                  onGameTypeChange(data, rulesData)
                                }
                                filter={{
                                  search: {
                                    gameId: values.game,
                                    company: currencyWiseCompanySelectedDropdownFilterData,
                                  },
                                  pagination: { recordPerPage: 1000000 },
                                }}
                              />
                            </div>
                          )}
                          {values.gameType && (
                            <FieldArray
                              name="titles"
                              render={(arrayHelpers) => (
                                <>
                                  {values.titles &&
                                    values.titles.map(
                                      (item, index) =>
                                        item.isContest && (
                                          <div
                                            key={index}
                                            className="col-lg-12 d-flex p-0"
                                          >
                                            <div className="col-lg-12">
                                              {item.isSelection &&
                                                item.name &&
                                                item.name !== "-" && (
                                                  <div className="col-lg-12 mt-3">
                                                    <div
                                                      role="group"
                                                      aria-labelledby="my-radio-group"
                                                      className="radio-inline"
                                                    >
                                                      <label className="mr-3 col-4 p-0">
                                                        {item.name} :{" "}
                                                      </label>
                                                      <div className="radio-inline col-7">
                                                        {game &&
                                                          game.settings[
                                                            `title${index +
                                                              1}Values`
                                                          ]?.map(
                                                            (
                                                              mapOption,
                                                              ind
                                                            ) => (
                                                              <div className="col-sm-6">
                                                                <label
                                                                  key={`mapOption${ind}`}
                                                                  className="radio"
                                                                >
                                                                  <Field
                                                                    type="radio"
                                                                    name={`titles[${index}].value`}
                                                                    value={
                                                                      mapOption.value
                                                                    }
                                                                  />
                                                                  <span></span>
                                                                  {
                                                                    mapOption.value
                                                                  }
                                                                </label>
                                                              </div>
                                                            )
                                                          )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              {!item.isSelection &&
                                                item.name &&
                                                item.name !== "-" && (
                                                  <Field
                                                    name={`titles[${index}].value`}
                                                    component={Input}
                                                    placeholder={
                                                      values.titles[index].name
                                                    }
                                                    label={
                                                      values.titles[index].name
                                                    }
                                                    required
                                                  />
                                                )}
                                            </div>
                                          </div>
                                        )
                                    )}
                                </>
                              )}
                            />
                          )}
                        </div>
                      </div>
                    )}

                    {steps[current].code === "prizepoolStep" && (
                      <div>
                        <div className="offset-xxl-2 col-xxl-8">
                          <h4 className="mb-10 font-weight-bold text-dark">
                            Setup Your {steps[current].title}
                          </h4>
                          <div
                            className="pb-5 row d-flex"
                            data-wizard-type="step-content"
                            data-wizard-state="current"
                          >
                            <div className="col-lg-6 mb-5">
                              <Field
                                name="totalPlayers"
                                component={Input}
                                placeholder="Total Players"
                                label="Total Players"
                                type="number"
                                // validate={validateData}
                                min={0}
                                disabled={values?.totalJoinedPlayers >= 1}
                                onChange={(e) =>
                                  onValuesChange(e, values, setFieldValue)
                                }
                              />
                            </div>
                            <div className="col-lg-6 mb-5">
                              <Field
                                name="entryFee"
                                component={Input}
                                placeholder="Entry Fee"
                                label="Entry Fee"
                                type="number"
                                min={0}
                                disabled={values?.totalJoinedPlayers >= 1}
                                onChange={(e) =>
                                  onValuesChange(e, values, setFieldValue)
                                }
                              />
                            </div>
                            {values.winningTerm === "point base" && (
                              <div className="col-lg-6 mb-5">
                                <Field
                                  name="killPoints"
                                  component={Input}
                                  placeholder="Per kill / Max Loses"
                                  label="Per kill / Max Loses"
                                  type="number"
                                  min={0}
                                  disabled={values?.totalJoinedPlayers >= 1}
                                  onChange={(e) =>
                                    onValuesChange(e, values, setFieldValue)
                                  }
                                />
                              </div>
                            )}
                            <div className="col-lg-6">
                              {/* <CustomeSelect
                                  name="prizePoolType"
                                  label="Prize Pool Type"
                                  data={typeArr}
                                  placeholder="Prize Pool Type"
                                  labelKey="name"
                                  valueKey="_id"
                                  value={values.prizePoolType}
                                  isRequired={true}
                                /> */}
                              <label>Prize Pool Type</label>
                              <DropdownReactSelect
                                placeholder={"Prize Pool Type..."}
                                name={"prizePoolType"}
                                value={prizePoolTypeSelectedDropdownFilterData}
                                isMulti={false}
                                isClearable={false}
                                isSearchable={true}
                                closeMenuOnSelect={true}
                                isDisabled={values?.totalJoinedPlayers >= 1}
                                options={typeArr}
                                onChange={(e) => {
                                  let valuesInfo = e;
                                  onPrizePoolChange(
                                    e,
                                    valuesInfo,
                                    setFieldValue
                                  );
                                }}
                              />
                            </div>
                            <div className="col-lg-6">
                              <Field
                                name="rewardDisplayText"
                                component={Input}
                                placeholder="Winning Rewards Display Text"
                                label="Winning Rewards Display Text"
                                // disabled={isInputDisable}
                                type="text"
                                // onChange={(e) =>
                                //   onValuesChange(e, values, setFieldValue)
                                // }
                                disabled={
                                  prizePoolTypeSelectedDropdownFilterData?.value &&
                                      prizePoolTypeSelectedDropdownFilterData?.value ===
                                        "rewards"
                                      ? false
                                      : true
                                }
                              />
                            </div>
                            <div className="col-lg-6 mb-5">
                              <Field
                                name="prizePool"
                                component={Input}
                                placeholder="Prize Pool"
                                label="Prize Pool"
                                type="number"
                                disabled={
                                  prizePoolTypeSelectedDropdownFilterData?.value &&
                                      prizePoolTypeSelectedDropdownFilterData?.value ===
                                        "amount"
                                      ? false
                                      : true
                                }
                                // disabled={values?.totalJoinedPlayers >= 1}
                                // validate={validateData}
                                onChange={(e) =>
                                  onValuesChange(e, values, setFieldValue)
                                }
                                min={0}
                              />
                            </div>
                            <div className="col-lg-6 mb-5">
                              <Field
                                name="platformFee"
                                component={Input}
                                placeholder="Platform Fee(%)"
                                label="Platform Fee(%)"
                                disabled={values?.totalJoinedPlayers >= 1}
                                type="number"
                                readOnly={true}
                                min={0}
                              />
                            </div>
                            <div className="col-lg-6 mb-5">
                              <Field
                                name="totalWinners"
                                component={Input}
                                placeholder="Total Winners"
                                label="Total Winners"
                                disabled={values?.totalJoinedPlayers >= 1}
                                type="number"
                                // validate={validateData}
                                min={0}
                              />
                            </div>
                          </div>
                        </div>

                        <Col lg={24} md={24} sm={24} xs={24}>
                          <Row>
                            <div className="col-md-6">
                              <h3>PRICE POOL INFO</h3>
                            </div>
                            <div className="col-md-6 text-right">
                              <div className="d-inline-flex font-weight-bold w-130px">
                                Total Winners: <span>{totalWinners}</span>
                              </div>
                              <div className="d-inline-flex font-weight-bold w-auto">
                                Total Amount:<span>{totalAmount}</span>
                              </div>
                            </div>
                          </Row>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col">Rank (From)</th>
                                <th scope="col">Rank (To)</th>
                                <th scope="col">Amount (Per Person)</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col">Prize</th>
                                <th scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <FieldArray
                                name="prizePooInfo"
                                render={(arrayHelpers) => (
                                  <>
                                    {values.prizePooInfo &&
                                      values.prizePooInfo.map(
                                        (title, index) => (
                                          <tr key={index}>
                                            <td>
                                              <Field
                                                name={`prizePooInfo[${index}].rankFrom`}
                                                component={Input}
                                                placeholder={`Rank From`}
                                                required
                                                type="number"
                                                disabled={
                                                  values?.totalJoinedPlayers >=
                                                  1
                                                }
                                                min={0}
                                                onChange={(e) =>
                                                  setTotalAmountWinner(
                                                    e,
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                name={`prizePooInfo[${index}].rankTo`}
                                                component={Input}
                                                placeholder={`Rank To`}
                                                required
                                                min={0}
                                                disabled={
                                                  values?.totalJoinedPlayers >=
                                                  1
                                                }
                                                type="number"
                                                onChange={(e) =>
                                                  setTotalAmountWinner(
                                                    e,
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                              />
                                              {perRankFromAndTo != undefined &&
                                                Number(
                                                  perRankFromAndTo[index]?.from
                                                ) >
                                                  Number(
                                                    perRankFromAndTo[index]?.to
                                                  ) && (
                                                  <div style={{ color: "red" }}>
                                                    Rank (To) should be more
                                                    then Rank (From).
                                                  </div>
                                                )}
                                            </td>
                                            <td>
                                              <Field
                                                name={`prizePooInfo[${index}].amount`}
                                                component={Input}
                                                placeholder={`Amount (Per Person)`}
                                                required
                                                type="number"
                                                min={0}
                                                onChange={(e) =>
                                                  setTotalAmountWinner(
                                                    e,
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                                disabled={
                                                  prizePoolTypeSelectedDropdownFilterData?.value &&
                                                      prizePoolTypeSelectedDropdownFilterData?.value !==
                                                        "rewards"
                                                      ? false
                                                      : true
                                                }
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                name={`prizePooInfo[${index}].totalAmount`}
                                                component={Input}
                                                placeholder={`Total Amount`}
                                                required
                                                readOnly={true}
                                                type="number"
                                                min={0}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                name={`prizePooInfo[${index}].prize`}
                                                component={Input}
                                                placeholder={`Prize`}
                                                required
                                                type="text"
                                                // value={enteredPrizes[index]}
                                                // value ={values?.rewardDisplayText}
                                                disabled={
                                                  prizePoolTypeSelectedDropdownFilterData?.value &&
                                                      prizePoolTypeSelectedDropdownFilterData?.value ===
                                                        "rewards"
                                                      ? false
                                                      : true
                                                }
                                              />
                                            </td>
                                            <td>
                                              {/* <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                  arrayHelpers.remove(index)
                                                }
                                              >
                                                Remove
                                              </button> */}
                                              <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                  removePrizePoolInfo(
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    <tr>
                                      <td colSpan="6">
                                        <button
                                          type="button"
                                          className="btn btn-success"
                                          onClick={() => arrayHelpers.push("")}
                                        >
                                          Add Prizepool
                                        </button>
                                      </td>
                                    </tr>
                                  </>
                                )}
                              />
                            </tbody>
                          </table>
                        </Col>

                        {values.winningTerm === "point base" && (
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Row>
                              <Col lg={12} md={12} sm={24} xs={24}>
                                <h3>POINT PRICE INFO</h3>
                              </Col>
                            </Row>
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th scope="col">Rank (From)</th>
                                  <th scope="col">Rank (To)</th>
                                  <th scope="col">Points</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <FieldArray
                                  name="pointpool"
                                  render={(arrayHelpers) => (
                                    <>
                                      {values.pointpool &&
                                        values.pointpool.map((title, index) => (
                                          <tr key={index}>
                                            <td>
                                              <Field
                                                name={`pointpool[${index}].rankFrom`}
                                                component={Input}
                                                placeholder={`Rank From`}
                                                required
                                                type="number"
                                                min={0}
                                                onChange={(e) =>
                                                  setPointPrizePool(
                                                    e,
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                name={`pointpool[${index}].rankTo`}
                                                component={Input}
                                                placeholder={`Rank To`}
                                                required
                                                type="number"
                                                min={0}
                                                onChange={(e) =>
                                                  setPointPrizePool(
                                                    e,
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                name={`pointpool[${index}].point`}
                                                component={Input}
                                                placeholder={`Point`}
                                                required
                                                type="number"
                                                min={0}
                                              />
                                            </td>
                                            <td>
                                              {/* <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                  arrayHelpers.remove(index)
                                                }
                                              >
                                                Remove
                                              </button> */}
                                              <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                  removePointPoolInfo(
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </td>
                                          </tr>
                                        ))}
                                      <tr>
                                        <td colSpan="6">
                                          <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={() =>
                                              arrayHelpers.push("")
                                            }
                                          >
                                            Add Pointpool
                                          </button>
                                        </td>
                                      </tr>
                                    </>
                                  )}
                                />
                              </tbody>
                            </table>
                          </Col>
                        )}
                      </div>
                    )}

                    {steps[current].code === "roundStep" && (
                      <div
                        className="pb-5"
                        data-wizard-type="step-content"
                        data-wizard-state="current"
                      >
                        <h4 className="mb-10 font-weight-bold text-dark">
                          Setup Your {steps[current].title}
                        </h4>
                        <div className="col-md-12 p-0">
                          <FieldArray
                            name="rounds"
                            render={(arrayHelpers) => (
                              <>
                                {values.rounds &&
                                  values.rounds.map((round, rind) => (
                                    <Card
                                      key={"round" + rind}
                                      className="gx-card clearfix"
                                    >
                                      <CardHeader
                                        title={`Round ${rind + 1}`}
                                      ></CardHeader>
                                      <CardBody>
                                        <Row>
                                          <Col lg={12} md={12} sm={24} xs={24}>
                                            <Field
                                              name={`rounds[${rind}].name`}
                                              component={Input}
                                              placeholder={`Name`}
                                              // disabled={isInputDisable}
                                              readOnly={
                                                (!id || isDateModified
                                                  ? values.rounds[rind]
                                                    ? values.rounds[rind]
                                                        .isSaved
                                                    : false
                                                  : false) ||
                                                values?.totalJoinedPlayers >= 1 // Set to `false` when none of the conditions apply
                                              }
                                              required
                                            />
                                          </Col>

                                          {rind > 0 && (
                                            <Col
                                              lg={12}
                                              md={12}
                                              sm={24}
                                              xs={24}
                                            >
                                              <div
                                                role="group"
                                                aria-labelledby="my-radio-group"
                                                className="radio-inline"
                                              >
                                                <label className="mr-3 col-4 p-0">
                                                  Is Final :{" "}
                                                </label>
                                                <label className="radio my-radio-btn">
                                                  <Field
                                                    type="radio"
                                                    name={`rounds[${rind}].isFinalRound`}
                                                    value="no"
                                                    disabled={
                                                      (!id || isDateModified
                                                        ? values.rounds[rind]
                                                          ? values.rounds[rind]
                                                              .isSaved
                                                          : false
                                                        : false) ||
                                                      values?.totalJoinedPlayers >=
                                                        1
                                                    }
                                                  />
                                                  <span></span>No
                                                </label>
                                                <label className="radio my-radio-btn">
                                                  <Field
                                                    type="radio"
                                                    name={`rounds[${rind}].isFinalRound`}
                                                    value="yes"
                                                    disabled={
                                                      (!id || isDateModified
                                                        ? values.rounds[rind]
                                                          ? values.rounds[rind]
                                                              .isSaved
                                                          : false
                                                        : false) ||
                                                      values?.totalJoinedPlayers >=
                                                        1
                                                    }
                                                  />
                                                  <span></span>Yes
                                                </label>
                                              </div>
                                            </Col>
                                          )}
                                          <Col className="col-md-12">
                                            <h3>Contests Info</h3>
                                            <FieldArray
                                              name={`rounds[${rind}].matches`}
                                              render={(marrayHelpers) => (
                                                <table className="table table-bordered w-100">
                                                  <thead>
                                                    <tr>
                                                      <th scope="col">#</th>
                                                      {rind > 0 && (
                                                        <th
                                                          width="150"
                                                          scope="col"
                                                        >
                                                          Contests
                                                        </th>
                                                      )}
                                                      <th
                                                        width="200"
                                                        scope="col"
                                                      >
                                                        Date
                                                      </th>
                                                      <th
                                                        width="120"
                                                        scope="col"
                                                      >
                                                        Time Slot
                                                      </th>
                                                      <th scope="col">
                                                        User Count
                                                      </th>
                                                      <th scope="col">
                                                        Winner Count
                                                      </th>
                                                      <th scope="col">
                                                        Action
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {values.rounds[rind]
                                                      .matches &&
                                                      values.rounds[
                                                        rind
                                                      ].matches.map(
                                                        (match, rmind) => (
                                                          <tr
                                                            key={
                                                              rind +
                                                              "_matche" +
                                                              rmind
                                                            }
                                                          >
                                                            <td>
                                                              <Field
                                                                name={`rounds[${rind}].matches[${rmind}].matchId`}
                                                                component={
                                                                  Input
                                                                }
                                                                disabled={
                                                                  values?.totalJoinedPlayers >=
                                                                  1
                                                                }
                                                                readOnly={true}
                                                                value={`R${rind +
                                                                  1}M${rmind +
                                                                  1}`}
                                                              />
                                                            </td>
                                                            {rind > 0 && (
                                                              <td
                                                                className={
                                                                  rind > 0
                                                                    ? ""
                                                                    : "hide"
                                                                }
                                                              >
                                                                <Multiselect
                                                                  name={`rounds[${rind}].matches[${rmind}].contest`}
                                                                  className="form-control"
                                                                  showCheckbox={
                                                                    true
                                                                  }
                                                                  options={ContestsMultiSelectOptions(
                                                                    rind,
                                                                    rmind,
                                                                    values
                                                                  )}
                                                                  // displayValue="name"
                                                                  closeOnSelect={
                                                                    false
                                                                  }
                                                                  isObject={
                                                                    false
                                                                  }
                                                                  disable={
                                                                    (isDateModified
                                                                      ? values
                                                                          .rounds[
                                                                          rind
                                                                        ]
                                                                        ? values
                                                                            .rounds[
                                                                            rind
                                                                          ]
                                                                            .isSaved
                                                                        : false
                                                                      : false) ||
                                                                    values?.totalJoinedPlayers >=
                                                                      1
                                                                  }
                                                                  selectedValues={
                                                                    values
                                                                      .rounds[
                                                                      rind
                                                                    ].matches[
                                                                      rmind
                                                                    ].contest
                                                                  }
                                                                  onSelect={(
                                                                    data
                                                                  ) =>
                                                                    selectedContest(
                                                                      data,
                                                                      rind,
                                                                      rmind,
                                                                      values,
                                                                      setFieldValue
                                                                    )
                                                                  }
                                                                  onRemove={(
                                                                    data
                                                                  ) =>
                                                                    selectedContest(
                                                                      data,
                                                                      rind,
                                                                      rmind,
                                                                      values,
                                                                      setFieldValue
                                                                    )
                                                                  }
                                                                />
                                                              </td>
                                                            )}
                                                            <td>
                                                              {/* <DatePickerField
                                                                                      name={`rounds[${rind}].matches[${rmind}].date`}
                                                                                      // minDate={getminDate(rind, rmind, values)}
                                                                                      // maxDate={moment(values.endDate)}
                                                                                      readOnly={values.rounds[rind] ? values.rounds[rind].isSaved : false}
                                                                                      onChange={(data) => matchDateTime(data, rind, rmind, values, setFieldValue)}
                                                                                  /> */}
                                                              {id ? (
                                                                <DateTimePicker
                                                                  date={
                                                                    id &&
                                                                    moment(
                                                                      values
                                                                        .rounds[
                                                                        rind
                                                                      ].matches[
                                                                        rmind
                                                                      ].date
                                                                    )
                                                                  }
                                                                  key={`rounds[${rind}].matches[${rmind}].date`}
                                                                  format={
                                                                    "DD-MM-YYYY"
                                                                  }
                                                                  // minDate={!id && getminDate(rind, rmind, values)}
                                                                  // maxDate={!id && moment(values.endDate)}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    matchDate(
                                                                      e,
                                                                      rind,
                                                                      rmind,
                                                                      values,
                                                                      setFieldValue
                                                                    )
                                                                  }
                                                                  //  readOnly={isDateModified ? values.rounds[rind] ? values.rounds[rind].isSaved : false : isInputDisable}
                                                                  readOnly={
                                                                    values?.totalJoinedPlayers >=
                                                                    1
                                                                  }
                                                                />
                                                              ) : (
                                                                //   <DateTimePicker
                                                                //   // date={id && moment(values.rounds[rind].matches[rmind].date)}
                                                                //   date={values.rounds[rind].matches[rmind].date}
                                                                //   key={`rounds[${rind}].matches[${rmind}].date`}
                                                                //   format={'DD-MM-YYYY'}
                                                                //   minDate={!id && !values.rounds[rind].isSaved && values.startDate
                                                                //     ? new Date(values.startDate)
                                                                //     : false}
                                                                //   maxDate={!id && !values.rounds[rind].isSaved && values.startDate
                                                                //     ? moment(values.endDate)
                                                                //   : false}
                                                                //   onChange={(e) => matchDate(e, rind, rmind, values, setFieldValue)}
                                                                //   readOnly={values.rounds[rind] ? values.rounds[rind].isSaved : false}
                                                                // />
                                                                <DateTimePicker
                                                                  // date={id && moment(values.rounds[rind].matches[rmind].date)}
                                                                  date={
                                                                    values
                                                                      .rounds[
                                                                      rind
                                                                    ].matches[
                                                                      rmind
                                                                    ].date
                                                                  }
                                                                  key={`rounds[${rind}].matches[${rmind}].date`}
                                                                  format={
                                                                    "DD-MM-YYYY"
                                                                  }
                                                                  maxDate={
                                                                    values.endDate
                                                                      ? moment(
                                                                          values.endDate
                                                                        ).add(
                                                                          1,
                                                                          "days"
                                                                        )
                                                                      : false
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    matchDate(
                                                                      e,
                                                                      rind,
                                                                      rmind,
                                                                      values,
                                                                      setFieldValue
                                                                    )
                                                                  }
                                                                  //readOnly={values.rounds[rind] ? values.rounds[rind].isSaved : false}
                                                                  readOnly={
                                                                    values?.totalJoinedPlayers >=
                                                                    1
                                                                  }
                                                                />
                                                              )}
                                                            </td>
                                                            <td>
                                                              {/* <TimePickerField
                                                                                      name={`rounds[${rind}].matches[${rmind}].time`}
                                                                                      format="hh:mm a"
                                                                                      // minDate={getminDate(rind, rmind, values)}
                                                                                      // maxDate={moment(values.endDate)}
                                                                                      readOnly={values.rounds[rind] ? values.rounds[rind].isSaved : false}
                                                                                  /> */}
                                                              {id ? (
                                                                <TimePicker
                                                                  date={
                                                                    id &&
                                                                    moment(
                                                                      values
                                                                        .rounds[
                                                                        rind
                                                                      ].matches[
                                                                        rmind
                                                                      ].time
                                                                    )
                                                                  }
                                                                  key={`rounds[${rind}].matches[${rmind}].time`}
                                                                  format={
                                                                    "HH:mm"
                                                                  }
                                                                  // minDate={getminDate(rind, rmind, values)}
                                                                  // maxDate={moment(values.endDate)}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    matchTime(
                                                                      e,
                                                                      rind,
                                                                      rmind,
                                                                      values,
                                                                      setFieldValue
                                                                    )
                                                                  }
                                                                  //readOnly={!id || isDateModified ? values.rounds[rind] ? values.rounds[rind].isSaved : false : isInputDisable}
                                                                  readOnly={
                                                                    values?.totalJoinedPlayers >=
                                                                    1
                                                                  }
                                                                />
                                                              ) : (
                                                                // <TimePicker
                                                                //   date={values.rounds[rind].matches[rmind].time}
                                                                //   key={`rounds[${rind}].matches[${rmind}].time`}
                                                                //   format={'hh:mm a'}
                                                                //   // minDate={!id && values.startDate
                                                                //   //   ? moment(values.startDate).format('hh:mm a')
                                                                //   //   : false}
                                                                //   // maxDate={!id && values.startDate
                                                                //   //   ? moment(values.endDate).format('hh:mm a')
                                                                //   // : false}
                                                                //   minDate={!id && !values.rounds[rind].isSaved && values.startDate
                                                                //     ? new Date(values.startDate)
                                                                //     : false}
                                                                //   maxDate={!id && !values.rounds[rind].isSaved && values.startDate
                                                                //     ? moment(values.endDate)
                                                                //   : false}
                                                                //   onChange={(e) => matchTime(e, rind, rmind, values, setFieldValue)}
                                                                //   readOnly={values.rounds[rind] ? values.rounds[rind].isSaved : false}
                                                                // />
                                                                <TimePicker
                                                                  date={
                                                                    values
                                                                      .rounds[
                                                                      rind
                                                                    ].matches[
                                                                      rmind
                                                                    ].time
                                                                  }
                                                                  key={`rounds[${rind}].matches[${rmind}].time`}
                                                                  format={
                                                                    "HH:mm"
                                                                  }
                                                                  // minDate={!id && values.startDate
                                                                  //   ? moment(values.startDate).format('hh:mm a')
                                                                  //   : false}
                                                                  // maxDate={!id && values.startDate
                                                                  //   ? moment(values.endDate).format('hh:mm a')
                                                                  // : false}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    matchTime(
                                                                      e,
                                                                      rind,
                                                                      rmind,
                                                                      values,
                                                                      setFieldValue
                                                                    )
                                                                  }
                                                                  //readOnly={!id || isDateModified ? values.rounds[rind] ? values.rounds[rind].isSaved : false : isInputDisable}
                                                                  readOnly={
                                                                    values?.totalJoinedPlayers >=
                                                                    1
                                                                  }
                                                                />
                                                              )}
                                                            </td>
                                                            <td>
                                                              <Field
                                                                name={`rounds[${rind}].matches[${rmind}].userCount`}
                                                                component={
                                                                  Input
                                                                }
                                                                type="number"
                                                                min={0}
                                                                readOnly={
                                                                  (isDateModified
                                                                    ? rind > 0
                                                                      ? true
                                                                      : values
                                                                          .rounds[
                                                                          rind
                                                                        ]
                                                                      ? values
                                                                          .rounds[
                                                                          rind
                                                                        ]
                                                                          .isSaved
                                                                      : false
                                                                    : false) ||
                                                                  values?.totalJoinedPlayers >=
                                                                    1
                                                                }
                                                                onChange={(e) =>
                                                                  validateRoundUser(
                                                                    e,
                                                                    rind,
                                                                    rmind,
                                                                    values,
                                                                    setFieldValue
                                                                  )
                                                                }
                                                                // onChange={values.rounds[rind] ? values.rounds[rind].isSaved : false}
                                                              />
                                                            </td>
                                                            <td>
                                                              <Field
                                                                name={`rounds[${rind}].matches[${rmind}].winnerCount`}
                                                                component={
                                                                  Input
                                                                }
                                                                type="number"
                                                                min={0}
                                                                readOnly={
                                                                  (isDateModified
                                                                    ? values
                                                                        .rounds[
                                                                        rind
                                                                      ]
                                                                      ? values
                                                                          .rounds[
                                                                          rind
                                                                        ]
                                                                          .isSaved
                                                                      : false
                                                                    : false) ||
                                                                  values?.totalJoinedPlayers >=
                                                                    1
                                                                }
                                                                onChange={(e) =>
                                                                  checkWinnerValue(
                                                                    e,
                                                                    rind,
                                                                    rmind,
                                                                    values,
                                                                    setFieldValue
                                                                  )
                                                                }
                                                              />
                                                            </td>
                                                            <td>
                                                              {!id ||
                                                              isDateModified ? (
                                                                values.rounds
                                                                  .length ===
                                                                parseInt(rind) +
                                                                  1 ? (
                                                                  <button
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    title="Remove Match"
                                                                    onClick={() =>
                                                                      marrayHelpers.remove(
                                                                        rmind
                                                                      )
                                                                    }
                                                                  >
                                                                    <span className="flaticon2-trash"></span>
                                                                  </button>
                                                                ) : (
                                                                  <></>
                                                                )
                                                              ) : (
                                                                <></>
                                                              )}
                                                            </td>
                                                          </tr>
                                                        )
                                                      )}
                                                    <tr>
                                                      <td
                                                        colSpan={
                                                          rind > 0 ? "4" : "3"
                                                        }
                                                        align="right"
                                                      >
                                                        Total User
                                                      </td>
                                                      <td>
                                                        <GetTotalUser
                                                          ind={rind}
                                                          values={values}
                                                          type="totalUser"
                                                        />
                                                      </td>
                                                      <td>
                                                        <GetTotalUser
                                                          ind={rind}
                                                          values={values}
                                                          type="totalWinner"
                                                        />
                                                      </td>
                                                      <td></td>
                                                    </tr>
                                                    {values.rounds[rind] &&
                                                    values.rounds[rind]
                                                      .isSaved ? null : (
                                                      <>
                                                        {values.rounds[rind] &&
                                                        values.rounds[rind]
                                                          .isFinalRound ===
                                                          "yes" &&
                                                        values.rounds[rind]
                                                          .matches &&
                                                        values.rounds[rind]
                                                          .matches.length ===
                                                          1 ? null : (
                                                          <tr>
                                                            <td
                                                              colSpan="7"
                                                              className="text-center"
                                                            >
                                                              <button
                                                                type="button"
                                                                title="Add Match"
                                                                className="btn btn-success"
                                                                onClick={() =>
                                                                  marrayHelpers.push(
                                                                    {}
                                                                  )
                                                                }
                                                              >
                                                                Add Match
                                                              </button>
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </>
                                                    )}
                                                  </tbody>
                                                </table>
                                              )}
                                            />
                                          </Col>
                                          <Col className="text-center w-100">
                                            {!id || isDateModified ? (
                                              values.rounds[rind] &&
                                              values.rounds[rind].isSaved ? (
                                                <button
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={() =>
                                                    ResetRoundAdd(
                                                      values,
                                                      rind,
                                                      setFieldValue
                                                    )
                                                  }
                                                >
                                                  Reset Round
                                                </button>
                                              ) : (
                                                <button
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={() =>
                                                    MakeIsRoundAdd(
                                                      values,
                                                      rind,
                                                      setFieldValue
                                                    )
                                                  }
                                                >
                                                  Save Round
                                                </button>
                                              )
                                            ) : (
                                              <></>
                                            )}

                                            {!id || isDateModified ? (
                                              rind > 0 && (
                                                <button
                                                  type="button"
                                                  className="btn btn-danger ml-5"
                                                  title="Remove Round"
                                                  onClick={() =>
                                                    removeRound(
                                                      arrayHelpers,
                                                      rind,
                                                      values,
                                                      setFieldValue
                                                    )
                                                  }
                                                  readOnly={
                                                    values?.totalJoinedPlayers >=
                                                    1
                                                  } // Add the readOnly condition here
                                                >
                                                  <i className="flaticon2-trash"></i>
                                                </button>
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  ))}
                                {isAddRound && (
                                  <div className="col-md-12">
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      title="Add Round"
                                      onClick={() => {
                                        arrayHelpers.push({});
                                        setIsAddRound(false);
                                      }}
                                    >
                                      Add Round
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                          />
                        </div>
                      </div>
                    )}

                    {steps[current].code === "settingStep" && (
                      <div
                        className="pb-5"
                        data-wizard-type="step-content"
                        data-wizard-state="current"
                      >
                        <CardHeader title={"Setup Your Setting"}>
                          <div className="d-flex justify-content-end">
                            <CardHeaderToolbar>
                              <ul className="nav nav-tabs nav-bold nav-tabs-line">
                                {companyInOutCurrency.map((value, index) => {
                                  {
                                    /* console.log("####################value", value, companyInOutCurrency) */
                                  }
                                  return (
                                    <li className="nav-item">
                                      <div
                                        onClick={() => setActiveGameType(index)}
                                        className={
                                          activeGameType === index
                                            ? "active nav-link"
                                            : "nav-link"
                                        }
                                      >
                                        <span className="nav-text">
                                          {value?.selectedCompany?.label}
                                        </span>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </CardHeaderToolbar>
                          </div>
                        </CardHeader>
                        <CardBody>
                          {companyInOutCurrency.length > 0 &&
                            companyInOutCurrency.map((value, index) => (
                              <>
                                {activeGameType === index && (
                                  <>
                                    <div className="col-md-8 mt-4 offset-md-2">
                                      {/* <h4 className="mb-10 font-weight-bold text-dark">
                                      Setup Your {steps[current].title}
                                    </h4> */}
                                      {/* <div
                                        role="group"
                                        aria-labelledby="my-radio-group"
                                        className="radio-inline"
                                      >
                                        <label className="mr-3 col-4 p-0">
                                          Visibilty :{" "}
                                        </label>
                                        <label className="checkbox my-checkbox-btn">
                                          <Field
                                            type="checkbox"
                                            name={`companyInOutCurrency`}
                                            value={"companyPage"}
                                            onChange={(e) =>
                                              setTimeing(
                                                e.target.value,
                                                "touranmentVisibility",
                                                index
                                              )
                                            }
                                            disabled={isInputDisable}
                                            checked={
                                              value?.touranmentVisibility ===
                                              "companyPage"
                                            }
                                          />
                                          <span></span>On Company Page Only
                                        </label>
                                        <label className="checkbox my-checkbox-btn">
                                          <Field
                                            type="checkbox"
                                            name="visibilty"
                                            value={"portal"}
                                            onChange={(e) =>
                                              setTimeing(
                                                e.target.value,
                                                "touranmentVisibility",
                                                index
                                              )
                                            }
                                            disabled={isInputDisable}
                                            checked={
                                              value?.touranmentVisibility ===
                                              "portal"
                                            }
                                          />
                                          <span></span>Portal
                                        </label>
                                      </div> */}
                                      <div
                                        role="group"
                                        aria-labelledby="my-radio-group"
                                        className="radio-inline"
                                        // style={{paddingLeft:"103px"}}
                                      >
                                        <label className="mr-3 col-4 p-0">
                                          Tournament Status :{" "}
                                        </label>
                                        <label className="radio my-radio-btn">
                                          <Field
                                            type="radio"
                                            name="isConfirmStatus"
                                            value={"true"}
                                            onChange={(e) =>
                                              setTimeing(
                                                e.target.value,
                                                "touranmentStatus",
                                                index
                                              )
                                            }
                                            disabled={
                                              values?.totalJoinedPlayers >= 1
                                            }
                                            checked={
                                              value?.touranmentStatus === "true"
                                            }
                                          />
                                          <span></span>Confirmed
                                        </label>
                                        <label className="radio my-radio-btn">
                                          <Field
                                            type="radio"
                                            name="isConfirmStatus"
                                            value={"false"}
                                            onChange={(e) =>
                                              setTimeing(
                                                e.target.value,
                                                "touranmentStatus",
                                                index
                                              )
                                            }
                                            disabled={
                                              values?.totalJoinedPlayers >= 1
                                            }
                                            checked={
                                              value?.touranmentStatus !== "true"
                                            }
                                          />
                                          <span></span>Not Confirmed
                                        </label>
                                      </div>
                                      <div
                                        role="group"
                                        aria-labelledby="my-radio-group"
                                        className="radio-inline"
                                        // style={{paddingLeft:"103px"}}
                                      >
                                        <label className="mr-3 col-4 p-0">
                                          isFeatured :{" "}
                                        </label>
                                        <label className="radio my-radio-btn">
                                          <Field
                                            type="radio"
                                            name="isFeatured"
                                            value={"true"}
                                            onChange={(e) =>
                                              setTimeing(
                                                e.target.value,
                                                "isFeatured",
                                                index
                                              )
                                            }
                                            // disabled={
                                            //   values?.totalJoinedPlayers >= 1
                                            // }
                                            checked={
                                              value?.isFeatured === "true"
                                            }
                                          />
                                          <span></span>Yes
                                        </label>
                                        <label className="radio my-radio-btn">
                                          <Field
                                            type="radio"
                                            name="isFeatured"
                                            value={"false"}
                                            onChange={(e) =>
                                              setTimeing(
                                                e.target.value,
                                                "isFeatured",
                                                index
                                              )
                                            }
                                            // disabled={
                                            //   values?.totalJoinedPlayers >= 1
                                            // }
                                            checked={
                                              value?.isFeatured !== "true"
                                            }
                                          />
                                          <span></span>No
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-md-8 mt-4 offset-md-2">
                                      <div
                                        className="row d-flex"
                                        style={{
                                          justifyContent: "space-evenly",
                                        }}
                                      >
                               <div className="col-md-4 mt-4">
  <label>Event Table Image</label>
  <input
    name="eventTableImage"
    type="file"
    className="form-control"
    id={value?.selectedCompany?._id}
    label="Table Image"
    accept=".png, .jpg, .jpeg"
    onChange={(e) =>
      uploadImage(e, value?.selectedCompany?.value, "eventTableImage")
    }
  />
</div>
<div className="col-md-4 mt-4">
  <label>Banner Image</label>
  <input
    name="bannerImage"
    type="file"
    className="form-control"
    id={value?.selectedCompany?._id}
    label="Banner Image"
    accept=".png, .jpg, .jpeg"
    onChange={(e) =>
      uploadImage(e, value?.selectedCompany?.value, "bannerImage")
    }
  />
</div>

{/* Preview Section */}
<div className="col-md-8 mt-4 offset-md-2">
  <div className="row d-flex" style={{ justifyContent: "space-evenly" }}>
    {/* Event Table Image Preview */}
    <div className="col-md-4 mt-4">
    {tableImage?.[value?.selectedCompany?.value] && (
  <div className="thumb-image-display">
    <img
      src={tableImage[value?.selectedCompany?.value]}
      style={{ width: "100%" }}
      alt="Event Table Preview"
    />
  </div>
)}
    </div>

    {/* Banner Image Preview */}
    <div className="col-md-4 mt-4">
    {bannerImage?.[value?.selectedCompany?.value] && (
  <div className="thumb-image-display">
    <img
      src={bannerImage[value?.selectedCompany?.value]}
      style={{ width: "100%" }}
      alt="Banner Preview"
    />
  </div>
)}
    </div>
  </div>
</div>


                                        {/* <div className="col-md-4 mt-4">
                                          {creatives.hasOwnProperty(
                                            value?.selectedCompany?.value
                                          ) &&
                                            creatives[
                                              value?.selectedCompany?.value
                                            ]?.default && (
                                              <div className="thumb-image-display">
                                                <img
                                                  src={`${UIHelpers.imageUrl}${
                                                    creatives[
                                                      value?.selectedCompany
                                                        ?.value
                                                    ]?.default
                                                  }`}
                                                  style={{ width: "100%" }}
                                                />
                                              </div>
                                            )}
                                        </div> */}
                                      </div>
                                    </div>
                                    <div className="col-md-8 mt-4 offset-md-2">
                                      <h4>Rules</h4>
                                      <CKEditor
                                        // activeClassclassName="p10"
                                        id={value?.selectedCompany?._id}
                                        content={
                                          rules[value?.selectedCompany?.value]
                                        }
                                        events={{
                                          change: setRulesValue.bind(
                                            this,
                                            value?.selectedCompany?.value
                                          ),
                                        }}
                                      />
                                    </div>
                                  </>
                                )}
                              </>
                            ))}
                        </CardBody>
                      </div>
                    )}
                    {/* summary */}

                    {steps[current].code === "summaryStep" && (
                      <div className="col-md-12">
                        <div
                          className="pb-5"
                          data-wizard-type="step-content"
                          data-wizard-state="current"
                        >
                          <h4 className="mb-10 font-weight-bold text-dark">
                            {steps[current].title}
                          </h4>
                          <div
                            className={`card border-1 border-warning card-custom gutter-b mb-12 
                            `}
                          >
                            <div className="card-body">
                              <div className="contest-title">contest-title</div>
                              <div className="d-flex">
                                {/* <!--begin::Pic--> */}
                                <div className="flex-shrink-0 mr-7">
                                  <div className="symbol symbol-50 symbol-lg-120">
                                    <img
                                      alt="Pic"
                                      // src={`${
                                      //   process.env.REACT_APP_UPLOADED_FILE_URL
                                      // }/${game &&
                                      //   game.featuredImage &&
                                      //   game.featuredImage.default}`}
                                        src={imageUrl(game &&
                                          game.featuredImage &&
                                          game.featuredImage.default)}
                                    />
                                  </div>
                                </div>
                                {/* <!--end::Pic--> */}
                                <div className="flex-grow-1">
                                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                                    {/* <!--begin::Name--> */}
                                    <Link className="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3">
                                      {game && game.name} -{" "}
                                      {game && gameType.name}
                                      <i className="flaticon2-correct text-success icon-md ml-2"></i>
                                    </Link>
                                    {/* <!--begin::Contacts--> */}
                                    <div className="d-flex flex-lg-fill flex-wrap my-2">
                                      <Link className="text-muted text-hover-primary font-weight-bold">
                                        <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                          <i className="flaticon2-calendar-1"></i>
                                        </span>{" "}
                                        {moment(values?.startDate).format("ll")}{" "}
                                        - {moment(values?.endDate).format("ll")}
                                      </Link>
                                    </div>
                                    {/* <!--end::Contacts--> */}
                                    {/* <!--end::Name--> */}
                                  </div>
                                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                                    {/* <!--begin::Progress--> */}
                                    <div className="d-flex align-items-center flex-wrap justify-content-between">
                                      <div className="mt-4 mt-sm-0">
                                        <div className="progress progress-xs mt-2 mb-2 flex-shrink-0 w-150px w-xl-250px">
                                          <div
                                            className="progress-bar bg-success"
                                            role="progressbar"
                                            style={{
                                              width: `${parseInt(0 * 100) /
                                                parseInt(
                                                  values.totalPlayers
                                                )}%`,
                                            }}
                                            aria-valuenow="50"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                          ></div>
                                        </div>
                                        <span className="font-weight-bold font-size-sm mr-4">
                                          0
                                          {/* {values.totalJoinedPlayers || 0}{" "} */}
                                          Joined User
                                        </span>
                                        <span className="font-weight-bold font-size-sm ml-4">
                                          {parseInt(values.totalPlayers) -
                                            parseInt(0) || 0}{" "}
                                          Remaining users
                                        </span>
                                      </div>
                                    </div>
                                    {/* <!--end::Progress--> */}
                                  </div>
                                </div>
                              </div>
                              <div className="separator separator-solid my-5"></div>
                              <div className="d-flex align-items-center flex-wrap">
                                {/* <!--begin: Item--> */}
                                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                  <span className="mr-4">
                                    <i className="flaticon-piggy-bank icon-2x text-muted font-weight-bold"></i>
                                  </span>
                                  <div className="d-flex flex-column text-muted">
                                    <span className="font-weight-bolder font-size-sm">
                                      Prize pool
                                    </span>
                                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                                      <span className="text-dark-50 font-weight-bold">
                                        ₹
                                      </span>
                                      {values?.prizePool || 0}
                                    </span>
                                  </div>
                                </div>
                                {/* <!--end: Item--> */}
                                {/* <!--begin: Item--> */}
                                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                  <span className="mr-4">
                                    <i className="flaticon-confetti icon-2x text-muted font-weight-bold"></i>
                                  </span>
                                  <div className="d-flex flex-column text-muted">
                                    <span className="font-weight-bolder font-size-sm">
                                      Entry Fee
                                    </span>
                                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                                      <span className="text-dark-50 font-weight-bold">
                                        ₹
                                      </span>
                                      {values?.entryFee || 0}
                                    </span>
                                  </div>
                                </div>
                                {/* <!--end: Item--> */}
                              </div>
                              <div className="separator separator-solid my-5"></div>
                              <div className="d-flex align-items-center flex-wrap">
                                {/* <!--begin: Item--> */}
                                {values.rounds && (
                                  <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                    <span className="mr-4">
                                      <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"></i>
                                    </span>
                                    <div className="d-flex flex-column flex-lg-fill">
                                      <span className="text-muted font-weight-bolder font-size-sm">
                                        Total Rounds
                                      </span>
                                      <span className="font-weight-bolder font-size-h5 text-dark-75">
                                        {values?.rounds.length || 0}
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {/* <!--end: Item--> */}
                                {/* <!--begin: Item--> */}
                                {values.rounds && values.rounds.length > 0 && (
                                  <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                    <span className="mr-4">
                                      <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"></i>
                                    </span>
                                    <div className="d-flex flex-column flex-lg-fill">
                                      <span className="text-muted font-weight-bolder font-size-sm">
                                        Total Contests
                                      </span>
                                      <span className="font-weight-bolder font-size-h5 text-dark-75">
                                        {
                                          <GetNoOfMatches
                                            rounds={values?.rounds}
                                          />
                                        }
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {/* <!--end: Item--> */}
                                {/* <!--begin: Item--> */}
                                {values.winningTerm && (
                                  <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                    <span className="mr-4">
                                      <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"></i>
                                    </span>
                                    <div className="d-flex flex-column flex-lg-fill">
                                      <span className="text-muted font-weight-bolder font-size-sm">
                                        Winning Term
                                      </span>
                                      <span className="font-weight-bolder font-size-h5 text-dark-75">
                                        {values.winningTerm}
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {/* <!--end: Item--> */}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            {console.log(
                              "prizePoolType:",
                              prizePoolTypeSelectedDropdownFilterData?.value
                            )}{" "}
                            {/* Log prize pool type */}
                            {values.prizePooInfo &&
                              values.prizePooInfo.length > 0 && (
                                <div className="col-md-12 mt-4">
                                  <h4>POOL PRIZE INFO</h4>
                                  <table className="table table-bordered table-striped">
                                    <thead>
                                      <tr>
                                        <th>RANK FROM</th>
                                        <th>RANK TO</th>
                                        <th>AMOUNT</th>
                                        <th>TOTAL AMOUNT</th>
                                        <th>WINNING PRIZE</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {values.prizePooInfo.map(
                                        (data, index) => (
                                          <tr key={index}>
                                            <td>{data.rankFrom}</td>
                                            <td>{data.rankTo}</td>
                                            <td>
                                              {prizePoolTypeSelectedDropdownFilterData?.value ===
                                              "rewards"
                                                ? "N/A"
                                                : data.amount}
                                            </td>
                                            <td>
                                              {prizePoolTypeSelectedDropdownFilterData?.value ===
                                              "rewards"
                                                ? "N/A"
                                                : data.totalAmount}
                                            </td>
                                            <td>
                                              {prizePoolTypeSelectedDropdownFilterData?.value ===
                                              "rewards"
                                                ? data.prize
                                                : "N/A"}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="d-flex justify-content-end border-top mt-5 pt-10">
                      <div className="mr-2">
                        {current > 0 && (
                          <button
                            type="button"
                            className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4 mr-4"
                            onClick={() => prev(values)}
                          >
                            Previous
                          </button>
                        )}
                        {current === 0 && (
                          <button
                            className="btn ml-4 btn-light-primary font-weight-bolder text-uppercase px-9 py-4 mr-4"
                            type="button"
                            onClick={backToList}
                          >
                            Cancel
                          </button>
                        )}
                        {current < steps.length - 1 &&
                          (helperFunc.isButtonAccess(
                            "tournament.closeTournaments.add"
                          ) ||
                            helperFunc.isButtonAccess(
                              "tournament.closeTournaments.update"
                            )) && (
                            <button
                              type="button"
                              className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                              disabled={isBtnDisable}
                              onClick={() => next(values)}
                            >
                              Next
                            </button>
                          )}
                        {current === steps.length - 1 &&
                          (!isSubmitBtnDisable ? (
                            (helperFunc.isButtonAccess(
                              "tournament.closeTournaments.add"
                            ) ) 
                              && (
                              <button
                                className="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                                type="submit"
                                disabled={isLoading} // Disable button when loading
                              >
                                {isLoading ? (
                                  <span
                                    className="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  id ? "Update" : "Save"
                                )}
                              </button>
                            )
                          ) : (
                            <button
                              className="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                              type="button"
                              disabled
                            >
                              {isLoading ? (
                                <span
                                  className="spinner-border spinner-border-sm mr-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                id ? "Update" : "Save"
                              )}
                            </button>
                          ))}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
export default GamerjiTournament;
